function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

import { pvId as t, Monitor as e } from "@payment/link-monitor";

function n(t, e, n, r, i, o, a) {
  try {
    var c = t[o](a),
        s = c.value;
  } catch (t) {
    return void n(t);
  }

  c.done ? e(s) : Promise.resolve(s).then(r, i);
}

function r(t) {
  return function () {
    var e = this,
        r = arguments;
    return new Promise(function (i, o) {
      var a = t.apply(e, r);

      function c(t) {
        n(a, i, o, c, s, "next", t);
      }

      function s(t) {
        n(a, i, o, c, s, "throw", t);
      }

      c(void 0);
    });
  };
}

function i(t, e) {
  if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
}

function o(t, e) {
  for (var n = 0; n < e.length; n++) {
    var r = e[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
  }
}

function a(t, e, n) {
  return e && o(t.prototype, e), n && o(t, n), t;
}

function c(t, e, n) {
  return e in t ? Object.defineProperty(t, e, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : t[e] = n, t;
}

var s,
    u = (function (t) {
  var e = function (t) {
    var e,
        n = Object.prototype,
        r = n.hasOwnProperty,
        i = "function" == typeof Symbol ? Symbol : {},
        o = i.iterator || "@@iterator",
        a = i.asyncIterator || "@@asyncIterator",
        c = i.toStringTag || "@@toStringTag";

    function s(t, e, n) {
      return Object.defineProperty(t, e, {
        value: n,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }), t[e];
    }

    try {
      s({}, "");
    } catch (t) {
      s = function s(t, e, n) {
        return t[e] = n;
      };
    }

    function u(t, e, n, r) {
      var i = e && e.prototype instanceof y ? e : y,
          o = Object.create(i.prototype),
          a = new S(r || []);
      return o._invoke = function (t, e, n) {
        var r = p;
        return function (i, o) {
          if (r === h) throw new Error("Generator is already running");

          if (r === f) {
            if ("throw" === i) throw o;
            return j();
          }

          for (n.method = i, n.arg = o;;) {
            var a = n.delegate;

            if (a) {
              var c = E(a, n);

              if (c) {
                if (c === v) continue;
                return c;
              }
            }

            if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) {
              if (r === p) throw r = f, n.arg;
              n.dispatchException(n.arg);
            } else "return" === n.method && n.abrupt("return", n.arg);
            r = h;
            var s = l(t, e, n);

            if ("normal" === s.type) {
              if (r = n.done ? f : d, s.arg === v) continue;
              return {
                value: s.arg,
                done: n.done
              };
            }

            "throw" === s.type && (r = f, n.method = "throw", n.arg = s.arg);
          }
        };
      }(t, n, a), o;
    }

    function l(t, e, n) {
      try {
        return {
          type: "normal",
          arg: t.call(e, n)
        };
      } catch (t) {
        return {
          type: "throw",
          arg: t
        };
      }
    }

    t.wrap = u;
    var p = "suspendedStart",
        d = "suspendedYield",
        h = "executing",
        f = "completed",
        v = {};

    function y() {}

    function m() {}

    function g() {}

    var b = {};
    s(b, o, function () {
      return this;
    });
    var w = Object.getPrototypeOf,
        A = w && w(w(M([])));
    A && A !== n && r.call(A, o) && (b = A);
    var x = g.prototype = y.prototype = Object.create(b);

    function C(t) {
      ["next", "throw", "return"].forEach(function (e) {
        s(t, e, function (t) {
          return this._invoke(e, t);
        });
      });
    }

    function k(t, e) {
      function n(i, o, a, c) {
        var s = l(t[i], t, o);

        if ("throw" !== s.type) {
          var u = s.arg,
              p = u.value;
          return p && "object" == _typeof(p) && r.call(p, "__await") ? e.resolve(p.__await).then(function (t) {
            n("next", t, a, c);
          }, function (t) {
            n("throw", t, a, c);
          }) : e.resolve(p).then(function (t) {
            u.value = t, a(u);
          }, function (t) {
            return n("throw", t, a, c);
          });
        }

        c(s.arg);
      }

      var i;

      this._invoke = function (t, r) {
        function o() {
          return new e(function (e, i) {
            n(t, r, e, i);
          });
        }

        return i = i ? i.then(o, o) : o();
      };
    }

    function E(t, n) {
      var r = t.iterator[n.method];

      if (r === e) {
        if (n.delegate = null, "throw" === n.method) {
          if (t.iterator["return"] && (n.method = "return", n.arg = e, E(t, n), "throw" === n.method)) return v;
          n.method = "throw", n.arg = new TypeError("The iterator does not provide a 'throw' method");
        }

        return v;
      }

      var i = l(r, t.iterator, n.arg);
      if ("throw" === i.type) return n.method = "throw", n.arg = i.arg, n.delegate = null, v;
      var o = i.arg;
      return o ? o.done ? (n[t.resultName] = o.value, n.next = t.nextLoc, "return" !== n.method && (n.method = "next", n.arg = e), n.delegate = null, v) : o : (n.method = "throw", n.arg = new TypeError("iterator result is not an object"), n.delegate = null, v);
    }

    function I(t) {
      var e = {
        tryLoc: t[0]
      };
      1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
    }

    function O(t) {
      var e = t.completion || {};
      e.type = "normal", delete e.arg, t.completion = e;
    }

    function S(t) {
      this.tryEntries = [{
        tryLoc: "root"
      }], t.forEach(I, this), this.reset(!0);
    }

    function M(t) {
      if (t) {
        var n = t[o];
        if (n) return n.call(t);
        if ("function" == typeof t.next) return t;

        if (!isNaN(t.length)) {
          var i = -1,
              a = function n() {
            for (; ++i < t.length;) {
              if (r.call(t, i)) return n.value = t[i], n.done = !1, n;
            }

            return n.value = e, n.done = !0, n;
          };

          return a.next = a;
        }
      }

      return {
        next: j
      };
    }

    function j() {
      return {
        value: e,
        done: !0
      };
    }

    return m.prototype = g, s(x, "constructor", g), s(g, "constructor", m), m.displayName = s(g, c, "GeneratorFunction"), t.isGeneratorFunction = function (t) {
      var e = "function" == typeof t && t.constructor;
      return !!e && (e === m || "GeneratorFunction" === (e.displayName || e.name));
    }, t.mark = function (t) {
      return Object.setPrototypeOf ? Object.setPrototypeOf(t, g) : (t.__proto__ = g, s(t, c, "GeneratorFunction")), t.prototype = Object.create(x), t;
    }, t.awrap = function (t) {
      return {
        __await: t
      };
    }, C(k.prototype), s(k.prototype, a, function () {
      return this;
    }), t.AsyncIterator = k, t.async = function (e, n, r, i, o) {
      void 0 === o && (o = Promise);
      var a = new k(u(e, n, r, i), o);
      return t.isGeneratorFunction(n) ? a : a.next().then(function (t) {
        return t.done ? t.value : a.next();
      });
    }, C(x), s(x, c, "Generator"), s(x, o, function () {
      return this;
    }), s(x, "toString", function () {
      return "[object Generator]";
    }), t.keys = function (t) {
      var e = [];

      for (var n in t) {
        e.push(n);
      }

      return e.reverse(), function n() {
        for (; e.length;) {
          var r = e.pop();
          if (r in t) return n.value = r, n.done = !1, n;
        }

        return n.done = !0, n;
      };
    }, t.values = M, S.prototype = {
      constructor: S,
      reset: function reset(t) {
        if (this.prev = 0, this.next = 0, this.sent = this._sent = e, this.done = !1, this.delegate = null, this.method = "next", this.arg = e, this.tryEntries.forEach(O), !t) for (var n in this) {
          "t" === n.charAt(0) && r.call(this, n) && !isNaN(+n.slice(1)) && (this[n] = e);
        }
      },
      stop: function stop() {
        this.done = !0;
        var t = this.tryEntries[0].completion;
        if ("throw" === t.type) throw t.arg;
        return this.rval;
      },
      dispatchException: function dispatchException(t) {
        if (this.done) throw t;
        var n = this;

        function i(r, i) {
          return c.type = "throw", c.arg = t, n.next = r, i && (n.method = "next", n.arg = e), !!i;
        }

        for (var o = this.tryEntries.length - 1; o >= 0; --o) {
          var a = this.tryEntries[o],
              c = a.completion;
          if ("root" === a.tryLoc) return i("end");

          if (a.tryLoc <= this.prev) {
            var s = r.call(a, "catchLoc"),
                u = r.call(a, "finallyLoc");

            if (s && u) {
              if (this.prev < a.catchLoc) return i(a.catchLoc, !0);
              if (this.prev < a.finallyLoc) return i(a.finallyLoc);
            } else if (s) {
              if (this.prev < a.catchLoc) return i(a.catchLoc, !0);
            } else {
              if (!u) throw new Error("try statement without catch or finally");
              if (this.prev < a.finallyLoc) return i(a.finallyLoc);
            }
          }
        }
      },
      abrupt: function abrupt(t, e) {
        for (var n = this.tryEntries.length - 1; n >= 0; --n) {
          var i = this.tryEntries[n];

          if (i.tryLoc <= this.prev && r.call(i, "finallyLoc") && this.prev < i.finallyLoc) {
            var o = i;
            break;
          }
        }

        o && ("break" === t || "continue" === t) && o.tryLoc <= e && e <= o.finallyLoc && (o = null);
        var a = o ? o.completion : {};
        return a.type = t, a.arg = e, o ? (this.method = "next", this.next = o.finallyLoc, v) : this.complete(a);
      },
      complete: function complete(t, e) {
        if ("throw" === t.type) throw t.arg;
        return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), v;
      },
      finish: function finish(t) {
        for (var e = this.tryEntries.length - 1; e >= 0; --e) {
          var n = this.tryEntries[e];
          if (n.finallyLoc === t) return this.complete(n.completion, n.afterLoc), O(n), v;
        }
      },
      "catch": function _catch(t) {
        for (var e = this.tryEntries.length - 1; e >= 0; --e) {
          var n = this.tryEntries[e];

          if (n.tryLoc === t) {
            var r = n.completion;

            if ("throw" === r.type) {
              var i = r.arg;
              O(n);
            }

            return i;
          }
        }

        throw new Error("illegal catch attempt");
      },
      delegateYield: function delegateYield(t, n, r) {
        return this.delegate = {
          iterator: M(t),
          resultName: n,
          nextLoc: r
        }, "next" === this.method && (this.arg = e), v;
      }
    }, t;
  }(t.exports);

  try {
    regeneratorRuntime = e;
  } catch (t) {
    "object" == (typeof globalThis === "undefined" ? "undefined" : _typeof(globalThis)) ? globalThis.regeneratorRuntime = e : Function("r", "regeneratorRuntime = r")(e);
  }
}(s = {
  exports: {}
}, s.exports), s.exports);

function l(t, e) {
  if (null == t) return {};

  var n,
      r,
      i = function (t, e) {
    if (null == t) return {};
    var n,
        r,
        i = {},
        o = Object.keys(t);

    for (r = 0; r < o.length; r++) {
      n = o[r], e.indexOf(n) >= 0 || (i[n] = t[n]);
    }

    return i;
  }(t, e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(t);

    for (r = 0; r < o.length; r++) {
      n = o[r], e.indexOf(n) >= 0 || Object.prototype.propertyIsEnumerable.call(t, n) && (i[n] = t[n]);
    }
  }

  return i;
}

function p(t, e) {
  (null == e || e > t.length) && (e = t.length);

  for (var n = 0, r = new Array(e); n < e; n++) {
    r[n] = t[n];
  }

  return r;
}

function d(t) {
  return function (t) {
    if (Array.isArray(t)) return p(t);
  }(t) || function (t) {
    if ("undefined" != typeof Symbol && null != t[Symbol.iterator] || null != t["@@iterator"]) return Array.from(t);
  }(t) || function (t, e) {
    if (t) {
      if ("string" == typeof t) return p(t, e);
      var n = Object.prototype.toString.call(t).slice(8, -1);
      return "Object" === n && t.constructor && (n = t.constructor.name), "Map" === n || "Set" === n ? Array.from(t) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? p(t, e) : void 0;
    }
  }(t) || function () {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }();
}

function h(t, e, n) {
  return e in t ? Object.defineProperty(t, e, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : t[e] = n, t;
}

function f(t, e) {
  if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
}

function v(t, e) {
  for (var n = 0; n < e.length; n++) {
    var r = e[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
  }
}

function y(t, e, n) {
  return e && v(t.prototype, e), n && v(t, n), t;
}

function m(t) {
  if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t;
}

function g(t) {
  return (g = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  })(t);
}

function b(t, e, n) {
  return (b = "undefined" != typeof Reflect && Reflect.get ? Reflect.get : function (t, e, n) {
    var r = function (t, e) {
      for (; !Object.prototype.hasOwnProperty.call(t, e) && null !== (t = g(t));) {
        ;
      }

      return t;
    }(t, e);

    if (r) {
      var i = Object.getOwnPropertyDescriptor(r, e);
      return i.get ? i.get.call(n) : i.value;
    }
  })(t, e, n || t);
}

function w(t, e) {
  return (w = Object.setPrototypeOf || function (t, e) {
    return t.__proto__ = e, t;
  })(t, e);
}

function A(t) {
  return (A = "function" == typeof Symbol && "symbol" == _typeof(Symbol.iterator) ? function (t) {
    return _typeof(t);
  } : function (t) {
    return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : _typeof(t);
  })(t);
}

function x(t, e) {
  return !e || "object" !== A(e) && "function" != typeof e ? m(t) : e;
}

var C = /^\s*at (?:(.*?) ?\()?((?:file|https?|blob|chrome-extension|address|native|eval|webpack|<anonymous>|[-a-z]+:|.*bundle|\/).*?)(?::(\d+))?(?::(\d+))?\)?\s*$/i,
    k = /^\s*(.*?)(?:\((.*?)\))?(?:^|@)?((?:file|https?|blob|chrome|webpack|resource|moz-extension).*?:\/.*?|\[native code\]|[^@]*(?:bundle|\d+\.js))(?::(\d+))?(?::(\d+))?\s*$/i,
    E = /^\s*at (?:((?:\[object object\])?.+) )?\(?((?:file|ms-appx|https?|webpack|blob):.*?):(\d+)(?::(\d+))?\)?\s*$/i,
    I = /^(?:(\w+):)\/\/(?:(\w+)(?::(\w+))?@)([\w.-]+)(?::(\d+))?\/(.+)/;

function O(t) {
  return (t && t.message || "No error message").split("\n").filter(function (t) {
    return !!t;
  })[0];
}

function S(t) {
  try {
    var e = function (t) {
      if (!t.stack) return null;

      for (var e, n, r = [], i = t.stack.split("\n"), o = 0; o < i.length; ++o) {
        if (e = C.exec(i[o])) n = {
          filename: e[2] && 0 === e[2].indexOf("address at ") ? e[2].substr("address at ".length) : e[2],
          "function": e[1] || "?",
          lineno: e[3] ? +e[3] : null,
          colno: e[4] ? +e[4] : null
        };else if (e = E.exec(i[o])) n = {
          filename: e[2],
          "function": e[1] || "?",
          lineno: +e[3],
          colno: e[4] ? +e[4] : null
        };else {
          if (!(e = k.exec(i[o]))) continue;
          0 !== o || e[5] || void 0 === t.columnNumber || (r[0].column = t.columnNumber + 1), n = {
            filename: e[3],
            "function": e[1] || "?",
            lineno: e[4] ? +e[4] : null,
            colno: e[5] ? +e[5] : null
          };
        }
        !n["function"] && n.lineno && (n["function"] = "?"), r.push(n);
      }

      return r.length ? {
        value: O(t),
        type: t.name,
        stacktrace: {
          frames: r.reverse()
        }
      } : null;
    }(t);

    if (e) return e;
  } catch (t) {}

  return {
    value: O(t),
    type: t && t.name,
    stacktrace: {
      frames: []
    }
  };
}

var M = Object.assign || function (t) {
  for (var e = arguments.length, n = 1; n < e; n++) {
    var r = arguments[n];

    for (var i in r) {
      Object.prototype.hasOwnProperty.call(r, i) && (t[i] = r[i]);
    }
  }

  return t;
},
    j = function () {
  function t(e) {
    if (f(this, t), e.dsn) {
      var n = I.exec(e.dsn),
          r = n ? n.slice(1) : [],
          i = r[5].split("/"),
          o = i.slice(0, -1).join("/");
      this.apiUrl = r[0] + "://" + r[3] + (r[4] ? ":" + r[4] : "") + (o ? "/" + o : "") + "/api/" + i.pop() + "/store/", this.authHeader = "Sentry sentry_version=7,sentry_key=" + r[1] + (r[2] ? ",sentry_secret=" + r[2] : "");
    }

    this.environment = e.environment;
  }

  return y(t, [{
    key: "prepare",
    value: function value(t) {
      return M(this.getRequestBlank(), {
        exception: {
          values: [S(t)]
        }
      });
    }
  }, {
    key: "report",
    value: function value(t) {
      this.send(this.prepare(t));
    }
  }, {
    key: "send",
    value: function value(t) {
      if (this.apiUrl) {
        var e = new XMLHttpRequest();
        e.open("POST", this.apiUrl, !0), e.setRequestHeader("Content-type", "application/json"), e.setRequestHeader("X-Sentry-Auth", this.authHeader || ""), e.send(JSON.stringify(t));
      }
    }
  }, {
    key: "getRequestBlank",
    value: function value() {
      return {
        platform: "javascript",
        sdk: {
          name: "micro-sentry.javascript.browser",
          version: "0.0.0"
        },
        timestamp: Date.now() / 1e3,
        request: {
          url: window.location.toString(),
          headers: {
            "User-Agent": window.navigator.userAgent
          }
        },
        environment: this.environment
      };
    }
  }]), t;
}();

function D(t, e) {
  return "[object RegExp]" === Object.prototype.toString.call(e) ? e.test(t) : "string" == typeof e && -1 !== t.indexOf(e);
}

var N = function (t) {
  !function (t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
      constructor: {
        value: t,
        writable: !0,
        configurable: !0
      }
    }), e && w(t, e);
  }(n, j);

  var e = function (t) {
    var e = function () {
      if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
      if (Reflect.construct.sham) return !1;
      if ("function" == typeof Proxy) return !0;

      try {
        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
      } catch (t) {
        return !1;
      }
    }();

    return function () {
      var n,
          r = g(t);

      if (e) {
        var i = g(this).constructor;
        n = Reflect.construct(r, arguments, i);
      } else n = r.apply(this, arguments);

      return x(this, n);
    };
  }(n);

  function n(t) {
    var r;
    f(this, n), (r = e.call(this, t)).options = t, r.destroyed = !1, r._state = {};
    var i = r.options || {},
        o = i.plugins,
        a = void 0 === o ? [] : o,
        c = i.beforeSend,
        s = void 0 === c ? function (t) {
      return t;
    } : c,
        u = i.beforeBreadcrumb,
        l = void 0 === u ? function (t) {
      return t;
    } : u,
        p = i.blacklistUrls,
        d = void 0 === p ? [] : p,
        h = i.ignoreErrors,
        v = void 0 === h ? [] : h,
        y = i.release,
        g = void 0 === y ? void 0 : y;
    return r.plugins = a.map(function (t) {
      return new t(m(r));
    }), r.beforeSend = s, r.beforeBreadcrumb = l, r.blacklistUrls = d, r.ignoreErrors = v, r.release = g, r;
  }

  return y(n, [{
    key: "state",
    get: function get() {
      return this._state;
    }
  }, {
    key: "clearState",
    value: function value() {
      this._state = {};
    }
  }, {
    key: "setTags",
    value: function value(t) {
      return this.setKeyState("tags", Object.assign({}, t)), this;
    }
  }, {
    key: "setTag",
    value: function value(t, e) {
      return this.extendState({
        tags: h({}, t, e)
      }), this;
    }
  }, {
    key: "setExtra",
    value: function value(t, e) {
      return this.extendState({
        extra: h({}, t, e)
      }), this;
    }
  }, {
    key: "setExtras",
    value: function value(t) {
      return this.setKeyState("extra", Object.assign({}, t)), this;
    }
  }, {
    key: "setUser",
    value: function value(t) {
      return this.setKeyState("user", Object.assign({}, t)), this;
    }
  }, {
    key: "clone",
    value: function value() {
      var t = new n(Object.assign(Object.assign({}, this.options), {
        plugins: []
      }));
      return t.extendState(this.state), t;
    }
  }, {
    key: "withScope",
    value: function value(t) {
      var e = this.clone();
      t(e), e.destroy(), this.setBreadcrumbs(void 0);
    }
  }, {
    key: "addBreadcrumb",
    value: function value(t) {
      this.extendState({
        breadcrumbs: [Object.assign({
          timestamp: Date.now() / 1e3
        }, this.beforeBreadcrumb(t))]
      });
    }
  }, {
    key: "setBreadcrumbs",
    value: function value(t) {
      this.setKeyState("breadcrumbs", t);
    }
  }, {
    key: "captureMessage",
    value: function value(t, e) {
      this.send(Object.assign(Object.assign({}, this.getRequestBlank()), {
        message: t,
        level: e
      }));
    }
  }, {
    key: "destroy",
    value: function value() {
      this.destroyed = !0, this.plugins.forEach(function (t) {
        t.destroy && t.destroy();
      });
    }
  }, {
    key: "isIgnoredError",
    value: function value(t) {
      var e = this;
      return !!this.ignoreErrors.length && this.getPossibleEventMessages(t).some(function (t) {
        return e.ignoreErrors.some(function (e) {
          return D(t, e);
        });
      });
    }
  }, {
    key: "getRequestBlank",
    value: function value() {
      return Object.assign(Object.assign({}, b(g(n.prototype), "getRequestBlank", this).call(this)), this.state);
    }
  }, {
    key: "send",
    value: function value(t) {
      this.destroyed || this.isDeniedUrl(t) || this.isIgnoredError(t) || (b(g(n.prototype), "send", this).call(this, this.beforeSend(Object.assign({
        release: this.release
      }, t))), this.setBreadcrumbs(void 0));
    }
  }, {
    key: "getPossibleEventMessages",
    value: function value(t) {
      if (t.message) return [t.message];
      if (t.exception) try {
        var e = t.exception.values && t.exception.values[0] || {},
            n = e.type,
            r = void 0 === n ? "" : n,
            i = e.value,
            o = void 0 === i ? "" : i;
        return ["".concat(o), "".concat(r, ": ").concat(o)];
      } catch (t) {
        return [];
      }
      return [];
    }
  }, {
    key: "isDeniedUrl",
    value: function value(t) {
      if (!this.blacklistUrls.length) return !1;
      var e = this.getEventFilterUrl(t);
      return !!e && this.blacklistUrls.some(function (t) {
        return D(e, t);
      });
    }
  }, {
    key: "getEventFilterUrl",
    value: function value(t) {
      try {
        if (t.exception) {
          var e = t.exception.values && t.exception.values[0].stacktrace && t.exception.values[0].stacktrace.frames;
          return e && e[e.length - 1].filename || null;
        }

        return null;
      } catch (t) {
        return null;
      }
    }
  }, {
    key: "extendState",
    value: function value(t) {
      var e = this;
      this._state = Object.keys(t).reduce(function (n, r) {
        var i = e.state[r],
            o = Array.isArray(i) ? i : null,
            a = t[r],
            c = Array.isArray(a) ? a : null;
        return Object.assign(Object.assign({}, n), h({}, r, o || c ? [].concat(d(o || []), d(c || [])) : Object.assign(Object.assign({}, "string" != typeof i ? i : {}), "string" != typeof a ? a : {})));
      }, {});
    }
  }, {
    key: "setKeyState",
    value: function value(t, e) {
      this._state[t] = e;
    }
  }]), n;
}();

function T(t, e, n) {
  var r = t[e],
      i = n(r);
  if ("function" == typeof i) try {
    i.prototype = i.prototype || {}, Object.defineProperties(i, {
      __original__: {
        enumerable: !1,
        value: r
      }
    });
  } catch (t) {}
  t[e] = i;
}

function P(t) {
  if (!t) return {};
  var e = t.match(/^(([^:/?#]+):)?(\/\/([^/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?$/);
  if (!e) return {};
  var n = e[6] || "",
      r = e[8] || "";
  return {
    host: e[4],
    path: e[5],
    protocol: e[2],
    relative: e[5] + n + r
  };
}

function L() {
  var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [];
  return "Request" in window && t[0] instanceof Request && t[0].method ? String(t[0].method).toUpperCase() : t[1] && t[1].method ? String(t[1].method).toUpperCase() : "GET";
}

function B() {
  var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [];
  return "string" == typeof t[0] ? t[0] : "Request" in window && t[0] instanceof Request ? t[0].url : String(t[0]);
}

function Q(t) {
  return t && /^function fetch\(\)\s+\{\s+\[native code\]\s+\}$/.test(t.toString());
}

function F(t) {
  var e = t,
      n = [];
  if (!e || !e.tagName) return "";
  n.push(e.tagName.toLowerCase()), e.id && n.push("#".concat(e.id));
  var r = e.className;

  if (r && "string" == typeof r) {
    var i = r.split(/\s+/);
    n.concat(i.map(function (t) {
      return ".".concat(t);
    }));
  }

  return ["type", "name", "title", "alt", "automation-id"].forEach(function (t) {
    var r = e.getAttribute(t);
    r && n.push("[".concat(t, '="').concat(r, '"]'));
  }), n.join("");
}

function R(t) {
  try {
    for (var e, n = t, r = [], i = 0, o = 0, a = " > ".length; n && i++ < 5 && !("html" === (e = F(n)) || i > 1 && o + r.length * a + e.length >= 80);) {
      r.push(e), o += e.length, n = n.parentNode;
    }

    return r.reverse().join(" > ");
  } catch (t) {
    return "<unknown>";
  }
}

function z(t) {
  var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : " ";
  return Array.isArray(t) ? t.map(function (t) {
    try {
      return String(t);
    } catch (t) {
      return "";
    }
  }).filter(function (t) {
    return "" !== t;
  }).join(e) : "";
}

function U() {
  return "1.10.1";
}

!function () {
  function t(e) {
    f(this, t), this.client = e, this.subscriptions = [], this.initDOM(), this.initConsole(), this.initFetch(), this.initHistory(), this.initXHR();
  }

  y(t, [{
    key: "initXHR",
    value: function value() {
      if ("XMLHttpRequest" in window) {
        var t = this,
            e = XMLHttpRequest.prototype;
        T(e, "open", function (e) {
          return function () {
            for (var n = arguments.length, r = new Array(n), i = 0; i < n; i++) {
              r[i] = arguments[i];
            }

            var o = this,
                a = r[1];
            o.__sentry_xhr__ = {
              method: "string" == typeof r[0] ? r[0].toUpperCase() : r[0],
              url: r[1]
            }, "string" == typeof a && "POST" === o.__sentry_xhr__.method && a.match(/sentry_key/) && (o.__sentry_own_request__ = !0);

            var c = function c() {
              if (4 === o.readyState) {
                try {
                  o.__sentry_xhr__ && (o.__sentry_xhr__.status_code = o.status);
                } catch (t) {}

                t.xhrBreadcrumb({
                  args: r,
                  endTimestamp: Date.now(),
                  startTimestamp: Date.now(),
                  xhr: o
                });
              }
            };

            return "onreadystatechange" in o && "function" == typeof o.onreadystatechange ? T(o, "onreadystatechange", function (t) {
              return function () {
                c();

                for (var e = arguments.length, n = new Array(e), r = 0; r < e; r++) {
                  n[r] = arguments[r];
                }

                t.apply(o, n);
              };
            }) : o.addEventListener("readystatechange", c), e.apply(o, r);
          };
        }), T(e, "send", function (e) {
          return function () {
            for (var n = arguments.length, r = new Array(n), i = 0; i < n; i++) {
              r[i] = arguments[i];
            }

            return t.xhrBreadcrumb({
              args: r,
              startTimestamp: Date.now(),
              xhr: this
            }), e.apply(this, r);
          };
        });
      }
    }
  }, {
    key: "initHistory",
    value: function value() {
      var t = this,
          e = window.onpopstate;

      function n(e) {
        return function () {
          for (var n = arguments.length, r = new Array(n), i = 0; i < n; i++) {
            r[i] = arguments[i];
          }

          var o = r.length > 2 ? r[2] : void 0;

          if (o) {
            var a = t.lastHref,
                c = String(o);
            t.lastHref = c, t.historyBreadcrumb({
              from: a,
              to: c
            });
          }

          return e.apply(this, r);
        };
      }

      window.onpopstate = function () {
        var n = window.location.href,
            r = t.lastHref;

        if (t.lastHref = n, t.historyBreadcrumb({
          from: r,
          to: n
        }), e) {
          for (var i = arguments.length, o = new Array(i), a = 0; a < i; a++) {
            o[a] = arguments[a];
          }

          return e.apply(this, o);
        }
      }, T(window.history, "pushState", n), T(window.history, "replaceState", n);
    }
  }, {
    key: "destroy",
    value: function value() {
      this.subscriptions.forEach(function (t) {
        return t();
      });
    }
  }, {
    key: "initDOM",
    value: function value() {
      var t = this,
          e = function e(_e) {
        return t.prepareDomEvent("click", _e);
      },
          n = function n(e) {
        return t.prepareDomEvent("keypress", e);
      };

      window.document.addEventListener("click", e, !1), window.document.addEventListener("keypress", n, !1), this.subscriptions.push(function () {
        window.document.removeEventListener("click", e, !1), window.document.removeEventListener("keypress", n, !1);
      });
    }
  }, {
    key: "prepareDomEvent",
    value: function value(t, e) {
      var n;

      try {
        n = e.target ? R(e.target) : R(e);
      } catch (t) {
        n = "<unknown>";
      }

      0 !== n.length && this.client.addBreadcrumb({
        category: "ui.".concat(t),
        message: n
      });
    }
  }, {
    key: "initFetch",
    value: function value() {
      var t = this;
      (function () {
        if (!function () {
          if (!("fetch" in window)) return !1;

          try {
            return new Headers(), new Request(""), new Response(), !0;
          } catch (t) {
            return !1;
          }
        }()) return !1;
        if (Q(window.fetch)) return !0;
        var t = !1,
            e = window.document;
        if (e && "function" == typeof e.createElement) try {
          var n = e.createElement("iframe");
          n.sandbox.add("allow-scripts"), n.sandbox.add("allow-same-origin"), n.hidden = !0, e.head.appendChild(n), n.contentWindow && n.contentWindow.fetch && (t = Q(n.contentWindow.fetch)), e.head.removeChild(n);
        } catch (t) {}
        return t;
      })() && T(window, "fetch", function (e) {
        return function () {
          for (var n = arguments.length, r = new Array(n), i = 0; i < n; i++) {
            r[i] = arguments[i];
          }

          var o = {
            args: r,
            fetchData: {
              method: L(r),
              url: B(r)
            },
            startTimestamp: Date.now()
          };
          return t.fetchBreadcrumb(Object.assign({}, o)), e.apply(window, r).then(function (e) {
            return t.fetchBreadcrumb(Object.assign(Object.assign({}, o), {
              endTimestamp: Date.now(),
              response: e
            })), e;
          }, function (e) {
            throw t.fetchBreadcrumb(Object.assign(Object.assign({}, o), {
              endTimestamp: Date.now(),
              error: e
            })), e;
          });
        };
      });
    }
  }, {
    key: "fetchBreadcrumb",
    value: function value(t) {
      t.endTimestamp && (t.fetchData.url.match(/sentry_key/) && "POST" === t.fetchData.method || (t.error ? this.client.addBreadcrumb({
        category: "fetch",
        data: t.fetchData,
        level: "error",
        type: "http"
      }) : this.client.addBreadcrumb({
        category: "fetch",
        data: Object.assign(Object.assign({}, t.fetchData), {
          status_code: t.response.status
        }),
        type: "http"
      })));
    }
  }, {
    key: "xhrBreadcrumb",
    value: function value(t) {
      if (t.endTimestamp) {
        if (t.xhr.__sentry_own_request__) return;
        this.client.addBreadcrumb({
          category: "xhr",
          data: t.xhr.__sentry_xhr__,
          type: "http"
        });
      }
    }
  }, {
    key: "initConsole",
    value: function value() {
      var t = this;
      ["debug", "info", "warn", "error", "log", "assert"].forEach(function (e) {
        e in window.console && T(window.console, e, function (n) {
          return function () {
            for (var r = arguments.length, i = new Array(r), o = 0; o < r; o++) {
              i[o] = arguments[o];
            }

            var a = {
              category: "console",
              data: {
                arguments: i.map(function (t) {
                  try {
                    return JSON.stringify(t), t;
                  } catch (e) {
                    return Object.prototype.toString.call(t);
                  }
                }),
                logger: "console"
              },
              level: e,
              message: z(i, " ")
            };

            if ("assert" === e) {
              if (!1 !== i[0]) return;
              a.message = "Assertion failed: ".concat(z(i.slice(1), " ") || "console.assert"), a.data.arguments = i.slice(1);
            }

            t.client.addBreadcrumb(a), n && Function.prototype.apply.call(n, window.console, i);
          };
        });
      });
    }
  }, {
    key: "historyBreadcrumb",
    value: function value(t) {
      var e = t.from,
          n = t.to,
          r = P(window.location.href),
          i = P(e),
          o = P(n);
      i.path || (i = r), r.protocol === o.protocol && r.host === o.host && (n = o.relative), r.protocol === i.protocol && r.host === i.host && (e = i.relative), this.client.addBreadcrumb({
        category: "navigation",
        data: {
          from: e,
          to: n
        }
      });
    }
  }]);
}();
var Y = new N({
  dsn: "https://7de58d90007b4eb2818b8982ff3381ce@payment-sentry.duowan.com/3",
  release: "1.10.1",
  environment: "production",
  beforeSend: function beforeSend(t) {
    return t.request.url = window.location.pathname, t;
  }
});
Y.setTag("pvId", t);
var V = ["body"];

function W(t, e) {
  var n = Object.keys(t);

  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(t);
    e && (r = r.filter(function (e) {
      return Object.getOwnPropertyDescriptor(t, e).enumerable;
    })), n.push.apply(n, r);
  }

  return n;
}

function _(t) {
  for (var e = 1; e < arguments.length; e++) {
    var n = null != arguments[e] ? arguments[e] : {};
    e % 2 ? W(Object(n), !0).forEach(function (e) {
      c(t, e, n[e]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : W(Object(n)).forEach(function (e) {
      Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
    });
  }

  return t;
}

var H,
    G = new (function () {
  function t() {
    var e = this;
    i(this, t), c(this, "mockValue", void 0), c(this, "options", {}), c(this, "mockReturnValue", function (t) {
      e.mockValue = t;
    }), c(this, "serialize", function (t) {
      var e = Object.prototype.toString.call(t);
      return t && "[object Object]" === e ? Object.keys(t).map(function (e) {
        return encodeURIComponent(e) + "=" + encodeURIComponent(t[e]);
      }).join("&") : "";
    });
  }

  return a(t, [{
    key: "create",
    value: function value(t) {
      this.options = t;
    }
  }, {
    key: "get",
    value: function value(t) {
      var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
      return this.mockValue ? this.mockValue : (t = this.buildUrl(t, e.params), this.http(t, _(_({
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json;charset=UTF-8"
        },
        method: "GET"
      }, this.options), e)));
    }
  }, {
    key: "post",
    value: function value(t, e) {
      var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
      if (this.mockValue) return this.mockValue;
      var r = {
        Accept: "application/json"
      },
          i = e || n.data;
      return "form" === n.requestType ? (r["Content-Type"] = "application/x-www-form-urlencoded;charset=UTF-8", i = this.serialize(i)) : (r["Content-Type"] = "application/json;charset=UTF-8", i = i ? JSON.stringify(i) : null), this.http(t, _(_({
        headers: r,
        method: "POST",
        body: i
      }, this.options), n));
    }
  }, {
    key: "http",
    value: function value(t, e) {
      var n = this;
      return new Promise(function (r, i) {
        try {
          var o = new XMLHttpRequest(),
              a = !1,
              c = e.body,
              s = l(e, V),
              u = n.options.baseUrl && !/^(https?\:)?(\/\/)/.test(t) ? "".concat(n.options.baseUrl).concat(t) : t;

          if (o.open(e.method, u), Object.keys(e.headers).forEach(function (t) {
            o.setRequestHeader(t, e.headers[t]);
          }), o.onreadystatechange = function () {
            if (4 === o.readyState) {
              var t = {
                options: s,
                statusCode: o.status,
                url: u
              },
                  e = "";

              try {
                e = JSON.parse(o.responseText);
              } catch (t) {
                e = o.responseText;
              }

              if (/^(2|3)\d{2}$/.test(o.status.toString())) {
                try {
                  r(_({
                    data: e
                  }, t));
                } catch (n) {
                  r(_({
                    data: e
                  }, t));
                }

                return;
              }

              i(_({
                data: e
              }, t));
            }
          }, o.send(c), o.onabort = function () {
            a = !0;
          }, e.timeout) {
            if (a) return;
            setTimeout(function () {
              o.abort(), new Error("XMLHttpRequest timeout").code = "ETIMEDOUT", Y.report(new Error("".concat(e.baseUrl, " time out")));
            }, e.timeout);
          }
        } catch (t) {
          var p = t;
          throw p instanceof Object || (p = new Error(p)), p.isSent || (p.isSent = 1, Y.report(p)), p;
        }
      });
    }
  }, {
    key: "buildUrl",
    value: function value(t, e) {
      var n = Object.prototype.toString.call(e);
      if (!e || "[object Object]" !== n) return t;
      var r = Object.keys(e);
      return (t = decodeURIComponent(t).indexOf("?") > -1 ? "".concat(t, "&") : "".concat(t, "?")) + r.map(function (t) {
        return "".concat(t, "=").concat(e[t]);
      }).join("&");
    }
  }]), t;
}())(),
    Z = {
  Android: ["(?:(?:Orca-)?Android|Adr)[ /](?:[a-z]+ )?(\\d+[\\.\\d]*)", "Android|Silk-Accelerated=[a-z]{4,5}", "(?:TwitterAndroid).*[ /](?:[a-z]+ )?(\\d+[\\.\\d]*)", "FB4A.*FBSV/(\\d+[\\.\\d]*);", "BeyondPod|AntennaPod|Podkicker|DoggCatcher|Player FM|okhttp|Podcatcher Deluxe"],
  Linux: ["Arch ?Linux(?:[ /\\-](\\d+[\\.\\d]+))?", "VectorLinux(?: package)?(?:[ /\\-](\\d+[\\.\\d]+))?", "Linux(?:OS)?[^a-z]"],
  iOS: ["CFNetwork/889", "CFNetwork/887", "CFNetwork/811", "CFNetwork/808\\.3", "CFNetwork/808\\.2", "CFNetwork/808\\.1", "CFNetwork/808\\.0", "CFNetwork/808", "CFNetwork/758\\.4\\.3", "CFNetwork/758\\.3\\.15", "CFNetwork/758\\.2\\.[78]", "CFNetwork/758\\.1\\.6", "CFNetwork/758\\.0\\.2", "CFNetwork/711\\.5\\.6", "CFNetwork/711\\.4\\.6", "CFNetwork/711\\.3\\.18", "CFNetwork/711\\.2\\.23", "CFNetwork/711\\.1\\.1[26]", "CFNetwork/711\\.0\\.6", "CFNetwork/672\\.1", "CFNetwork/672\\.0", "CFNetwork/609\\.1", "CFNetwork/60[29]", "CFNetwork/548\\.1", "CFNetwork/548\\.0", "CFNetwork/485\\.13", "CFNetwork/485\\.12", "CFNetwork/485\\.10", "CFNetwork/485\\.2", "CFNetwork/467\\.12", "CFNetwork/459", "(?:CPU OS|iPh(?:one)?[ _]OS|iOS)[ _/](\\d+(?:[_\\.]\\d+)*)", "FBIOS.*FBSV/(\\d+[\\.\\d]*);", "(?:Apple-)?(?:iPhone|iPad|iPod)(?:.*Mac OS X.*Version/(\\d+\\.\\d+)|; Opera)?", "Podcasts/(?:[\\d\\.]+)|Instacast(?:HD)?/(?:\\d\\.[\\d\\.abc]+)|Pocket Casts, iOS|Overcast|Castro|Podcat|i[cC]atcher|RSSRadio/", "iTunes-(iPod|iPad|iPhone)/(?:[\\d\\.]+)"],
  MacOS: ["CFNetwork/887.*(x86_64)", "CFNetwork/811.*(x86_64)", "CFNetwork/807", "CFNetwork/760", "CFNetwork/720", "CFNetwork/673", "CFNetwork/596", "CFNetwork/520", "CFNetwork/454", "CFNetwork/(?:438|422|339|330|221|220|217)", "CFNetwork/12[89]", "CFNetwork/1\\.2", "CFNetwork/1\\.1", "Mac[ +]OS[ +]X(?:[ /](?:Version )?(\\d+(?:[_\\.]\\d+)+))?", "Mac (\\d+(?:[_\\.]\\d+)+)", "Darwin|Macintosh|Mac_PowerPC|PPC|Mac PowerPC|iMac|MacBook"],
  Windows: ["CYGWIN_NT-10.0|Windows NT 10.0|Windows 10", "CYGWIN_NT-6.4|Windows NT 6.4|Windows 10", "CYGWIN_NT-6.3|Windows NT 6.3|Windows 8.1", "CYGWIN_NT-6.2|Windows NT 6.2|Windows 8", "CYGWIN_NT-6.1|Windows NT 6.1|Windows 7", "CYGWIN_NT-6.0|Windows NT 6.0|Windows Vista", "CYGWIN_NT-5.2|Windows NT 5.2|Windows Server 2003 / XP x64", "CYGWIN_NT-5.1|Windows NT 5.1|Windows XP", "CYGWIN_NT-5.0|Windows NT 5.0|Windows 2000", "CYGWIN_NT-4.0|Windows NT 4.0|WinNT|Windows NT", "CYGWIN_ME-4.90|Win 9x 4.90|Windows ME", "CYGWIN_98-4.10|Win98|Windows 98", "CYGWIN_95-4.0|Win32|Win95|Windows 95|Windows_95", "Windows 3.1", "Windows"]
},
    X = (H = {}, {
  set: function set(t, e) {
    H[t] = e;
  },
  get: function get(t) {
    if (H.hasOwnProperty(t)) return H[t];
  }
}),
    J = function J(t, e) {
  try {
    var n = function (t) {
      var e = X.get(t);
      if (e) return e.value;
      var n = RegExp("(?:^|[^A-Z0-9-_]|[^A-Z0-9-]_|sprd-)(?:".concat(t, ")"), "i");
      return X.set(t, {
        value: n
      }), n;
    }(t).exec(e);

    return n ? n.slice(1) : null;
  } catch (t) {
    return null;
  }
};

function K(t, e) {
  var _n = "undefined" != typeof Symbol && t[Symbol.iterator] || t["@@iterator"];

  if (!_n) {
    if (Array.isArray(t) || (_n = function (t, e) {
      if (!t) return;
      if ("string" == typeof t) return q(t, e);
      var n = Object.prototype.toString.call(t).slice(8, -1);
      "Object" === n && t.constructor && (n = t.constructor.name);
      if ("Map" === n || "Set" === n) return Array.from(t);
      if ("Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return q(t, e);
    }(t)) || e && t && "number" == typeof t.length) {
      _n && (t = _n);

      var r = 0,
          i = function i() {};

      return {
        s: i,
        n: function n() {
          return r >= t.length ? {
            done: !0
          } : {
            done: !1,
            value: t[r++]
          };
        },
        e: function e(t) {
          throw t;
        },
        f: i
      };
    }

    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }

  var o,
      a = !0,
      c = !1;
  return {
    s: function s() {
      _n = _n.call(t);
    },
    n: function n() {
      var t = _n.next();

      return a = t.done, t;
    },
    e: function e(t) {
      c = !0, o = t;
    },
    f: function f() {
      try {
        a || null == _n["return"] || _n["return"]();
      } finally {
        if (c) throw o;
      }
    }
  };
}

function q(t, e) {
  (null == e || e > t.length) && (e = t.length);

  for (var n = 0, r = new Array(e); n < e; n++) {
    r[n] = t[n];
  }

  return r;
}

var $,
    tt,
    et,
    nt = function t() {
  i(this, t), c(this, "parse", function (t) {
    for (var e = null, n = 0, r = Object.keys(Z); n < r.length; n++) {
      var i,
          o = r[n],
          a = K(Z[o]);

      try {
        for (a.s(); !(i = a.n()).done;) {
          var c = i.value;
          if (J(c, t)) return e = o;
        }
      } catch (t) {
        a.e(t);
      } finally {
        a.f();
      }
    }

    return e;
  });
},
    rt = "https://h.online-metrix.net/fp/tags.js",
    it = "cybs_script",
    ot = "k8vif92e",
    at = "yyrisk",
    ct = "cybs",
    st = function () {
  var t;
  return function () {
    var e = r(u.mark(function e() {
      var n,
          r,
          i = arguments;
      return u.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              if (n = i.length > 0 && void 0 !== i[0] ? i[0] : "", !t) {
                e.next = 5;
                break;
              }

              return e.next = 4, t;

            case 4:
              return e.abrupt("return", e.sent);

            case 5:
              return r = G.get("".concat(n, "/v1/api/cashier/paysession"), {}).then(function (t) {
                return t.data.paySession;
              }), t = r, e.abrupt("return", r);

            case 8:
            case "end":
              return e.stop();
          }
        }
      }, e);
    }));
    return function () {
      return e.apply(this, arguments);
    };
  }();
}(),
    ut = function () {
  function t(e) {
    i(this, t), c(this, "host", void 0), this.host = e || "https://cashiers.myshopline.com";
  }

  return a(t, [{
    key: "init",
    value: function value() {
      var t = this;
      return st(this.host).then(function (e) {
        document.querySelector("#".concat(it)) || t.appendCybsScript(e);
        var n = new nt().parse(navigator.userAgent) || "Other";
        return e.label = ct, e.deviceType = t.getDeviceType(n), e.deviceOS = n, e;
      });
    }
  }, {
    key: "getDeviceType",
    value: function value(t) {
      return t ? "Linux" === t || "Windows" === t || "MacOS" === t ? "PC" : "iOS" === t || "Android" === t || "HarmonyOS" === t ? "Mobile" : "Other" : "Other";
    }
  }, {
    key: "appendCybsScript",
    value: function value(t) {
      var e = at + t.sessionId,
          n = "".concat(rt, "?org_id=").concat(ot, "&session_id=").concat(e);
      this.appendScript(n);
    }
  }, {
    key: "appendScript",
    value: function value(t, e) {
      var n,
          r = document.getElementsByTagName("head")[0],
          i = document.createElement("script");
      i.type = "text/javascript", i.src = t, i.id = it, null === (n = document.querySelector("#".concat(it))) || void 0 === n || n.remove(), i.onload = i.onreadystatechange = function () {
        this.readyState && "loaded" !== this.readyState && "complete" !== this.readyState || (e && e(), i.onload = i.onreadystatechange = null);
      }, r.appendChild(i);
    }
  }]), t;
}();

function lt(t, e) {
  var _n2 = "undefined" != typeof Symbol && t[Symbol.iterator] || t["@@iterator"];

  if (!_n2) {
    if (Array.isArray(t) || (_n2 = function (t, e) {
      if (!t) return;
      if ("string" == typeof t) return pt(t, e);
      var n = Object.prototype.toString.call(t).slice(8, -1);
      "Object" === n && t.constructor && (n = t.constructor.name);
      if ("Map" === n || "Set" === n) return Array.from(t);
      if ("Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return pt(t, e);
    }(t)) || e && t && "number" == typeof t.length) {
      _n2 && (t = _n2);

      var r = 0,
          i = function i() {};

      return {
        s: i,
        n: function n() {
          return r >= t.length ? {
            done: !0
          } : {
            done: !1,
            value: t[r++]
          };
        },
        e: function e(t) {
          throw t;
        },
        f: i
      };
    }

    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }

  var o,
      a = !0,
      c = !1;
  return {
    s: function s() {
      _n2 = _n2.call(t);
    },
    n: function n() {
      var t = _n2.next();

      return a = t.done, t;
    },
    e: function e(t) {
      c = !0, o = t;
    },
    f: function f() {
      try {
        a || null == _n2["return"] || _n2["return"]();
      } finally {
        if (c) throw o;
      }
    }
  };
}

function pt(t, e) {
  (null == e || e > t.length) && (e = t.length);

  for (var n = 0, r = new Array(e); n < e; n++) {
    r[n] = t[n];
  }

  return r;
}

function dt(t, e) {
  if (!t) return null;
  var n = t.content,
      r = t.props,
      i = t.children,
      o = document.createElement(n);
  if (Object.keys(r).forEach(function (t) {
    r[t] && o.setAttribute(t, r[t]);
  }), !e) return null;

  if (Array.isArray(i)) {
    var a,
        c = lt(i);

    try {
      for (c.s(); !(a = c.n()).done;) {
        dt(a.value, o);
      }
    } catch (t) {
      c.e(t);
    } finally {
      c.f();
    }
  } else "string" == typeof i ? o.textContent = i : i ? dt(i, o) : o.textContent = "";

  e.appendChild(o);
}

!function (t) {
  try {
    t.CreditCard = "CreditCard", t.FPX = "FPX", t.PaynowQrCode = "PaynowQrCode", t.AlipayQrCode = "AlipayQrCode", t.AlipayWap = "AlipayWap", t.Paypal = "Paypal", t.BankTransfer = "BankTransfer", t.Cash = "Cash", t.ChannelCashier = "ChannelCashier", t.VirtualAccount = "VirtualAccount";
  } catch (t) {
    var e = t;
    throw e instanceof Object || (e = new Error(e)), e.isSent || (e.isSent = 1, Y.report(e)), e;
  }
}($ || ($ = {})), function (t) {
  t.Oceanpay = "Oceanpay", t.Xendit = "Xendit";
}(tt || (tt = {})), function (t) {
  t.Redirect = "Redirect", t.Confirm = "Confirm", t.QrCode = "QrCode";
}(et || (et = {}));
var ht = [],
    ft = [];

function vt(t, e) {
  if (t && "undefined" != typeof document) {
    var n,
        r = !0 === e.prepend ? "prepend" : "append",
        i = !0 === e.singleTag,
        o = "string" == typeof e.container ? document.querySelector(e.container) : document.getElementsByTagName("head")[0];

    if (i) {
      var a = ht.indexOf(o);
      -1 === a && (a = ht.push(o) - 1, ft[a] = {}), n = ft[a] && ft[a][r] ? ft[a][r] : ft[a][r] = c();
    } else n = c();

    65279 === t.charCodeAt(0) && (t = t.substring(1)), n.styleSheet ? n.styleSheet.cssText += t : n.appendChild(document.createTextNode(t));
  }

  function c() {
    var t = document.createElement("style");
    if (t.setAttribute("type", "text/css"), e.attributes) for (var n = Object.keys(e.attributes), i = 0; i < n.length; i++) {
      t.setAttribute(n[i], e.attributes[n[i]]);
    }
    var a = "prepend" === r ? "afterbegin" : "beforeend";
    return o.insertAdjacentElement(a, t), t;
  }
}

vt('.pci-tooltip-wrap {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  cursor: pointer;\n  -webkit-tap-highlight-color: transparent;\n}\n\n.pci-tooltip-wrap::after {\n  display: none;\n  position: absolute;\n  top: -14px;\n  left: 50%;\n  content: "";\n  width: 0px;\n  height: 0px;\n  transform: translateX(-50%);\n  border: 7px solid;\n  border-color: rgba(30, 30, 30, .9) transparent transparent transparent;\n}\n\n.pci-tooltip-content {\n  display: none;\n  position: absolute;\n  bottom: 26px;\n  right: -17px;\n  box-sizing: content-box;\n  width: 180px;\n  padding: 6px 12px;\n  border-radius: 4px;\n  background-color: rgba(30, 30, 30, .9);\n  font-family: PingFang SC;\n  font-style: normal;\n  font-weight: 500;\n  font-size: 12px;\n  line-height: 18px;\n  color: rgba(255, 255, 255, .9);\n}\n\n.pci-tooltip-wrap:hover::after,\n.pci-tooltip-wrap:hover .pci-tooltip-content {\n  display: block;\n}', {});

var yt = function () {
  function t() {
    i(this, t);
  }

  return a(t, [{
    key: "mount",
    value: function value(t, e) {
      dt({
        content: "div",
        props: {
          "class": "pci-tooltip-wrap"
        },
        children: {
          content: "div",
          props: {
            "class": "pci-tooltip-content"
          },
          children: e
        }
      }, t);
    }
  }]), t;
}(),
    mt = function mt(t, e) {
  return new Promise(function () {
    var n = r(u.mark(function n(r, i) {
      var o;
      return u.wrap(function (n) {
        for (;;) {
          switch (n.prev = n.next) {
            case 0:
              return n.prev = 0, n.next = 3, G.post(t, e);

            case 3:
              o = n.sent, r(o), n.next = 12;
              break;

            case 7:
              n.prev = 7, n.t0 = n["catch"](0), Y.report(new Error(JSON.stringify({
                statusCode: null === n.t0 || void 0 === n.t0 ? void 0 : n.t0.statusCode,
                url: t,
                response: null === n.t0 || void 0 === n.t0 ? void 0 : n.t0.data
              }))), 400 !== n.t0.statusCode && (n.t0.data = {
                code: "2905",
                msg: "Payment failed due to network error",
                channelCode: "",
                channelMsg: ""
              }), i(n.t0);

            case 12:
            case "end":
              return n.stop();
          }
        }
      }, n, null, [[0, 7]]);
    }));
    return function (t, e) {
      return n.apply(this, arguments);
    };
  }());
};

function gt(t, e) {
  var n = document.createElement("form");

  for (var r in n.method = "post", n.action = t, e) {
    var i = document.createElement("input");
    i.name = r, i.value = e[r], n.appendChild(i);
  }

  document.body.appendChild(n), n.submit(), document.body.removeChild(n);
}

function bt(t, e) {
  return wt.apply(this, arguments);
}

function wt() {
  return (wt = r(u.mark(function t(e, n) {
    var i, o, a, c, s, l, p;
    return u.wrap(function (t) {
      for (;;) {
        switch (t.prev = t.next) {
          case 0:
            i = e.method, o = e.url, a = e.data, c = e.target, s = null == n ? void 0 : n.beforeRedirect, l = new Promise(function () {
              var t = r(u.mark(function t(e) {
                return u.wrap(function (t) {
                  for (;;) {
                    switch (t.prev = t.next) {
                      case 0:
                        if (!s) {
                          t.next = 9;
                          break;
                        }

                        return t.prev = 1, t.next = 4, s(c);

                      case 4:
                        t.next = 9;
                        break;

                      case 6:
                        t.prev = 6, t.t0 = t["catch"](1), console.error(t.t0);

                      case 9:
                        e(!0);

                      case 10:
                      case "end":
                        return t.stop();
                    }
                  }
                }, t, null, [[1, 6]]);
              }));
              return function (e) {
                return t.apply(this, arguments);
              };
            }()), p = new Promise(function (t) {
              setTimeout(t, 3e3);
            }), Promise.race([l, p]).then(function () {
              "POST" === i ? gt(o, a) : "GET" === i && (window.location.href = o);
            });

          case 5:
          case "end":
            return t.stop();
        }
      }
    }, t);
  }))).apply(this, arguments);
}

function At(t, e, n) {
  return xt.apply(this, arguments);
}

function xt() {
  return (xt = r(u.mark(function t(e, n, r) {
    var i;
    return u.wrap(function (t) {
      for (;;) {
        switch (t.prev = t.next) {
          case 0:
            if (console.log("handleNextAction", e), e.type !== et.Confirm) {
              t.next = 8;
              break;
            }

            return t.next = 4, mt(e.url, {
              paymentInstrument: {
                paymentMethod: r
              }
            })["catch"](function (t) {
              return t;
            });

          case 4:
            return i = t.sent, t.abrupt("return", Ct(i, n));

          case 8:
            e.type === et.Redirect && bt(e);

          case 9:
          case "end":
            return t.stop();
        }
      }
    }, t);
  }))).apply(this, arguments);
}

function Ct(t, e) {
  return kt.apply(this, arguments);
}

function kt() {
  return (kt = r(u.mark(function t(e, n) {
    var r;
    return u.wrap(function (t) {
      for (;;) {
        switch (t.prev = t.next) {
          case 0:
            if (200 !== e.statusCode) {
              t.next = 5;
              break;
            }

            return r = e.data.nextAction, t.abrupt("return", At(r, n));

          case 5:
            return t.abrupt("return", {
              paymentError: e.data
            });

          case 6:
          case "end":
            return t.stop();
        }
      }
    }, t);
  }))).apply(this, arguments);
}

function Et(t, e, n, r, i, o, a) {
  try {
    var c = t[o](a),
        s = c.value;
  } catch (t) {
    return void n(t);
  }

  c.done ? e(s) : Promise.resolve(s).then(r, i);
}

function It(t, e) {
  if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
}

function Ot(t, e) {
  for (var n = 0; n < e.length; n++) {
    var r = e[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
  }
}

function St(t, e, n) {
  return e && Ot(t.prototype, e), n && Ot(t, n), t;
}

function Mt(t, e, n) {
  return e in t ? Object.defineProperty(t, e, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : t[e] = n, t;
}

var jt = {
  exports: {}
};
!function (t) {
  var e = function (t) {
    var e,
        n = Object.prototype,
        r = n.hasOwnProperty,
        i = "function" == typeof Symbol ? Symbol : {},
        o = i.iterator || "@@iterator",
        a = i.asyncIterator || "@@asyncIterator",
        c = i.toStringTag || "@@toStringTag";

    function s(t, e, n) {
      return Object.defineProperty(t, e, {
        value: n,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }), t[e];
    }

    try {
      s({}, "");
    } catch (t) {
      s = function s(t, e, n) {
        return t[e] = n;
      };
    }

    function u(t, e, n, r) {
      var i = e && e.prototype instanceof y ? e : y,
          o = Object.create(i.prototype),
          a = new S(r || []);
      return o._invoke = function (t, e, n) {
        var r = p;
        return function (i, o) {
          if (r === h) throw new Error("Generator is already running");

          if (r === f) {
            if ("throw" === i) throw o;
            return j();
          }

          for (n.method = i, n.arg = o;;) {
            var a = n.delegate;

            if (a) {
              var c = E(a, n);

              if (c) {
                if (c === v) continue;
                return c;
              }
            }

            if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) {
              if (r === p) throw r = f, n.arg;
              n.dispatchException(n.arg);
            } else "return" === n.method && n.abrupt("return", n.arg);
            r = h;
            var s = l(t, e, n);

            if ("normal" === s.type) {
              if (r = n.done ? f : d, s.arg === v) continue;
              return {
                value: s.arg,
                done: n.done
              };
            }

            "throw" === s.type && (r = f, n.method = "throw", n.arg = s.arg);
          }
        };
      }(t, n, a), o;
    }

    function l(t, e, n) {
      try {
        return {
          type: "normal",
          arg: t.call(e, n)
        };
      } catch (t) {
        return {
          type: "throw",
          arg: t
        };
      }
    }

    t.wrap = u;
    var p = "suspendedStart",
        d = "suspendedYield",
        h = "executing",
        f = "completed",
        v = {};

    function y() {}

    function m() {}

    function g() {}

    var b = {};

    b[o] = function () {
      return this;
    };

    var w = Object.getPrototypeOf,
        A = w && w(w(M([])));
    A && A !== n && r.call(A, o) && (b = A);
    var x = g.prototype = y.prototype = Object.create(b);

    function C(t) {
      ["next", "throw", "return"].forEach(function (e) {
        s(t, e, function (t) {
          return this._invoke(e, t);
        });
      });
    }

    function k(t, e) {
      function n(i, o, a, c) {
        var s = l(t[i], t, o);

        if ("throw" !== s.type) {
          var u = s.arg,
              p = u.value;
          return p && "object" == _typeof(p) && r.call(p, "__await") ? e.resolve(p.__await).then(function (t) {
            n("next", t, a, c);
          }, function (t) {
            n("throw", t, a, c);
          }) : e.resolve(p).then(function (t) {
            u.value = t, a(u);
          }, function (t) {
            return n("throw", t, a, c);
          });
        }

        c(s.arg);
      }

      var i;

      this._invoke = function (t, r) {
        function o() {
          return new e(function (e, i) {
            n(t, r, e, i);
          });
        }

        return i = i ? i.then(o, o) : o();
      };
    }

    function E(t, n) {
      var r = t.iterator[n.method];

      if (r === e) {
        if (n.delegate = null, "throw" === n.method) {
          if (t.iterator["return"] && (n.method = "return", n.arg = e, E(t, n), "throw" === n.method)) return v;
          n.method = "throw", n.arg = new TypeError("The iterator does not provide a 'throw' method");
        }

        return v;
      }

      var i = l(r, t.iterator, n.arg);
      if ("throw" === i.type) return n.method = "throw", n.arg = i.arg, n.delegate = null, v;
      var o = i.arg;
      return o ? o.done ? (n[t.resultName] = o.value, n.next = t.nextLoc, "return" !== n.method && (n.method = "next", n.arg = e), n.delegate = null, v) : o : (n.method = "throw", n.arg = new TypeError("iterator result is not an object"), n.delegate = null, v);
    }

    function I(t) {
      var e = {
        tryLoc: t[0]
      };
      1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
    }

    function O(t) {
      var e = t.completion || {};
      e.type = "normal", delete e.arg, t.completion = e;
    }

    function S(t) {
      this.tryEntries = [{
        tryLoc: "root"
      }], t.forEach(I, this), this.reset(!0);
    }

    function M(t) {
      if (t) {
        var n = t[o];
        if (n) return n.call(t);
        if ("function" == typeof t.next) return t;

        if (!isNaN(t.length)) {
          var i = -1,
              a = function n() {
            for (; ++i < t.length;) {
              if (r.call(t, i)) return n.value = t[i], n.done = !1, n;
            }

            return n.value = e, n.done = !0, n;
          };

          return a.next = a;
        }
      }

      return {
        next: j
      };
    }

    function j() {
      return {
        value: e,
        done: !0
      };
    }

    return m.prototype = x.constructor = g, g.constructor = m, m.displayName = s(g, c, "GeneratorFunction"), t.isGeneratorFunction = function (t) {
      var e = "function" == typeof t && t.constructor;
      return !!e && (e === m || "GeneratorFunction" === (e.displayName || e.name));
    }, t.mark = function (t) {
      return Object.setPrototypeOf ? Object.setPrototypeOf(t, g) : (t.__proto__ = g, s(t, c, "GeneratorFunction")), t.prototype = Object.create(x), t;
    }, t.awrap = function (t) {
      return {
        __await: t
      };
    }, C(k.prototype), k.prototype[a] = function () {
      return this;
    }, t.AsyncIterator = k, t.async = function (e, n, r, i, o) {
      void 0 === o && (o = Promise);
      var a = new k(u(e, n, r, i), o);
      return t.isGeneratorFunction(n) ? a : a.next().then(function (t) {
        return t.done ? t.value : a.next();
      });
    }, C(x), s(x, c, "Generator"), x[o] = function () {
      return this;
    }, x.toString = function () {
      return "[object Generator]";
    }, t.keys = function (t) {
      var e = [];

      for (var n in t) {
        e.push(n);
      }

      return e.reverse(), function n() {
        for (; e.length;) {
          var r = e.pop();
          if (r in t) return n.value = r, n.done = !1, n;
        }

        return n.done = !0, n;
      };
    }, t.values = M, S.prototype = {
      constructor: S,
      reset: function reset(t) {
        if (this.prev = 0, this.next = 0, this.sent = this._sent = e, this.done = !1, this.delegate = null, this.method = "next", this.arg = e, this.tryEntries.forEach(O), !t) for (var n in this) {
          "t" === n.charAt(0) && r.call(this, n) && !isNaN(+n.slice(1)) && (this[n] = e);
        }
      },
      stop: function stop() {
        this.done = !0;
        var t = this.tryEntries[0].completion;
        if ("throw" === t.type) throw t.arg;
        return this.rval;
      },
      dispatchException: function dispatchException(t) {
        if (this.done) throw t;
        var n = this;

        function i(r, i) {
          return c.type = "throw", c.arg = t, n.next = r, i && (n.method = "next", n.arg = e), !!i;
        }

        for (var o = this.tryEntries.length - 1; o >= 0; --o) {
          var a = this.tryEntries[o],
              c = a.completion;
          if ("root" === a.tryLoc) return i("end");

          if (a.tryLoc <= this.prev) {
            var s = r.call(a, "catchLoc"),
                u = r.call(a, "finallyLoc");

            if (s && u) {
              if (this.prev < a.catchLoc) return i(a.catchLoc, !0);
              if (this.prev < a.finallyLoc) return i(a.finallyLoc);
            } else if (s) {
              if (this.prev < a.catchLoc) return i(a.catchLoc, !0);
            } else {
              if (!u) throw new Error("try statement without catch or finally");
              if (this.prev < a.finallyLoc) return i(a.finallyLoc);
            }
          }
        }
      },
      abrupt: function abrupt(t, e) {
        for (var n = this.tryEntries.length - 1; n >= 0; --n) {
          var i = this.tryEntries[n];

          if (i.tryLoc <= this.prev && r.call(i, "finallyLoc") && this.prev < i.finallyLoc) {
            var o = i;
            break;
          }
        }

        o && ("break" === t || "continue" === t) && o.tryLoc <= e && e <= o.finallyLoc && (o = null);
        var a = o ? o.completion : {};
        return a.type = t, a.arg = e, o ? (this.method = "next", this.next = o.finallyLoc, v) : this.complete(a);
      },
      complete: function complete(t, e) {
        if ("throw" === t.type) throw t.arg;
        return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), v;
      },
      finish: function finish(t) {
        for (var e = this.tryEntries.length - 1; e >= 0; --e) {
          var n = this.tryEntries[e];
          if (n.finallyLoc === t) return this.complete(n.completion, n.afterLoc), O(n), v;
        }
      },
      "catch": function _catch(t) {
        for (var e = this.tryEntries.length - 1; e >= 0; --e) {
          var n = this.tryEntries[e];

          if (n.tryLoc === t) {
            var r = n.completion;

            if ("throw" === r.type) {
              var i = r.arg;
              O(n);
            }

            return i;
          }
        }

        throw new Error("illegal catch attempt");
      },
      delegateYield: function delegateYield(t, n, r) {
        return this.delegate = {
          iterator: M(t),
          resultName: n,
          nextLoc: r
        }, "next" === this.method && (this.arg = e), v;
      }
    }, t;
  }(jt.exports);

  try {
    regeneratorRuntime = e;
  } catch (t) {
    Function("r", "regeneratorRuntime = r")(e);
  }
}();

var Dt = jt.exports,
    Nt = function () {
  function t() {
    It(this, t), Mt(this, "iframeHost", "*");
  }

  return St(t, [{
    key: "setUuid",
    value: function value(t) {
      this.uuid = t;
    }
  }, {
    key: "setIframeHost",
    value: function value(t) {
      this.iframeHost = t || "https://cashiers.myshopline.com";
    }
  }, {
    key: "setAttr",
    value: function value(t, e) {
      var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : this.iframeHost,
          r = {
        eventType: "setAttr",
        uuid: this.uuid,
        attr: t
      };
      this.postToChild(e + this.uuid, r, n);
    }
  }, {
    key: "setInitData",
    value: function value(t, e) {
      var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : this.iframeHost,
          r = {
        eventType: "initData",
        uuid: this.uuid,
        pvId: t.pvId
      };
      this.postToChild(e + this.uuid, r, n);
    }
  }, {
    key: "setStyle",
    value: function value(t, e, n) {
      var r = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : this.iframeHost,
          i = {
        eventType: "setStyle",
        uuid: this.uuid,
        type: e,
        name: n,
        style: t
      };
      this.postToChild(n + this.uuid, i, r);
    }
  }, {
    key: "postInput",
    value: function value(t, e, n) {
      var r = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : "*",
          i = {
        eventType: "input",
        name: t,
        uuid: this.uuid,
        isEmpty: e,
        isValid: n
      };
      this.postToParent(i, r);
    }
  }, {
    key: "postFocus",
    value: function value(t, e, n, r) {
      var i = arguments.length > 4 && void 0 !== arguments[4] ? arguments[4] : "*",
          o = {
        eventType: "focus",
        name: t,
        uuid: this.uuid,
        isEmpty: e,
        isFocus: n,
        isValid: r
      };
      this.postToParent(o, i);
    }
  }, {
    key: "postFocusToNumber",
    value: function value(t, e) {
      var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : "*",
          r = {
        eventType: "focus",
        name: t,
        uuid: this.uuid,
        isFocus: e
      };
      this.postToIframe("number".concat(this.uuid), r, n);
    }
  }, {
    key: "postPasteToNumber",
    value: function value(t) {
      var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "*",
          n = {
        eventType: "paste",
        name: t,
        uuid: this.uuid
      };
      this.postToIframe("number".concat(this.uuid), n, e);
    }
  }, {
    key: "brandChange",
    value: function value(t) {
      var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "*",
          n = {
        eventType: "brandChange",
        uuid: this.uuid,
        brand: t
      };
      this.postToParent(n, e);
    }
  }, {
    key: "postValue",
    value: function value(t, e, n) {
      var r = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : "*",
          i = {
        eventType: "input",
        name: t,
        uuid: this.uuid,
        value: e
      };
      this.postToIframe(n + this.uuid, i, r);
    }
  }, {
    key: "getValidate",
    value: function value(t, e) {
      var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : this.iframeHost,
          r = {
        eventType: "getValidate",
        uuid: this.uuid,
        hasCardName: t
      };
      this.postToChild(e + this.uuid, r, n);
    }
  }, {
    key: "postValidate",
    value: function value(t) {
      var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "*",
          n = {
        eventType: "validate",
        uuid: this.uuid,
        isValid: t
      };
      this.postToParent(n, e);
    }
  }, {
    key: "getCardBrand",
    value: function value(t) {
      var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : this.iframeHost,
          n = {
        eventType: "getCardBrand",
        uuid: this.uuid
      };
      this.postToChild(t + this.uuid, n, e);
    }
  }, {
    key: "postCardBrand",
    value: function value(t) {
      var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "*",
          n = {
        eventType: "getCardBrand",
        uuid: this.uuid,
        brand: t
      };
      this.postToParent(n, e);
    }
  }, {
    key: "pay",
    value: function value(t, e, n, r) {
      var i = arguments.length > 4 && void 0 !== arguments[4] ? arguments[4] : this.iframeHost,
          o = {
        eventType: "pay",
        uuid: this.uuid,
        nextAction: t,
        hasCardName: e,
        requestParams: n
      };
      this.postToChild(r + this.uuid, o, i);
    }
  }, {
    key: "payResult",
    value: function value(t, e) {
      var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : "*",
          r = {
        eventType: "payResult",
        uuid: this.uuid,
        status: t,
        value: e
      };
      this.postToParent(r, n);
    }
  }, {
    key: "loadFinished",
    value: function value(t) {
      var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "*",
          n = {
        eventType: "loadFinished",
        uuid: this.uuid,
        name: t
      };
      this.postToParent(n, e);
    }
  }, {
    key: "postToChild",
    value: function value(t, e, n) {
      var r;
      null === (r = window.frames[t]) || void 0 === r || r.postMessage(e, n);
    }
  }, {
    key: "postToParent",
    value: function value(t, e) {
      window.parent.postMessage(t, e);
    }
  }, {
    key: "postToIframe",
    value: function value(t, e, n) {
      var r;
      null === (r = window.parent.frames[t]) || void 0 === r || r.postMessage(e, n);
    }
  }]), t;
}(),
    Tt = function () {
  function e(t) {
    It(this, e), this.uuid = t;
  }

  return St(e, [{
    key: "setParentDom",
    value: function value(t) {
      this.parentDom = t;
    }
  }, {
    key: "mountIframe",
    value: function value(t, e, n, r) {
      var i = this.parentDom.querySelector(t);

      if (i) {
        var o = document.createElement("iframe");
        o.onload = r, o.src = n, o.name = e, o.id = e, o.style.width = "100%", o.style.height = "100%", o.style.border = "none", i.innerHTML = "", i.appendChild(o);
      } else console.error("Can't find the related dom node to mount the iframe");
    }
  }, {
    key: "unmountDom",
    value: function value(t) {
      var e = this.parentDom.querySelector(t);
      e && (e.innerHTML = "");
    }
  }, {
    key: "renderIframe",
    value: function value(e, n, r, i) {
      var o = this,
          a = e ? "".concat(e, "/pci-sdk") : "https://cashiers.myshopline.com/pci-sdk";
      n.forEach(function (e) {
        var n = "".concat(a, "/iframe.html?name=").concat(e);
        o.mountIframe('[data-pci="'.concat(e, '"]'), "".concat(e).concat(o.uuid), n, function () {
          var n = r.placeholder;
          i.setInitData({
            pvId: t
          }, e), n && n[e] && i.setAttr({
            placeholder: n[e]
          }, e);
        });
      });
    }
  }]), e;
}(),
    Pt = function () {
  function t(e) {
    It(this, t), Mt(this, "config", {}), Mt(this, "iframeLoaded", {}), this.config = e;
  }

  return St(t, [{
    key: "setValidateResolve",
    value: function value(t) {
      this.validateResolve = t;
    }
  }, {
    key: "setPayResolve",
    value: function value(t) {
      this.payResolve = t;
    }
  }, {
    key: "setPayReject",
    value: function value(t) {
      this.payReject = t;
    }
  }, {
    key: "setCardBrandResolve",
    value: function value(t) {
      this.cardBrandResolve = t;
    }
  }, {
    key: "setIframeLoaded",
    value: function value(t) {
      var e = this;
      t.forEach(function (t) {
        return e.iframeLoaded[t] = !1;
      });
    }
  }, {
    key: "handleEvent",
    value: function value(t) {
      var e = this,
          n = t.eventType,
          r = t.name,
          i = t.isEmpty,
          o = t.isValid,
          a = t.brand,
          c = t.isFocus,
          s = t.status,
          u = t.value;
      "focus" === n ? this.triggerEvent("onFocus", {
        fieldName: r,
        isEmpty: i,
        isFocus: c,
        isValid: o
      }) : "input" === n ? this.triggerEvent("onFieldValidChange", {
        fieldName: r,
        isValid: o,
        isEmpty: i
      }) : "brandChange" === n ? this.triggerEvent("onBrandChange", {
        brand: a
      }) : "validate" === n ? this.validateResolve(o) : "payResult" === n ? "success" === s ? this.payResolve(u) : this.payReject(u) : "getCardBrand" === n ? this.cardBrandResolve(a) : "loadFinished" === n && (this.iframeLoaded[r] = !0, Object.keys(this.iframeLoaded).every(function (t) {
        return e.iframeLoaded[t];
      }) && this.triggerEvent("onInit", {}));
    }
  }, {
    key: "triggerEvent",
    value: function value(t, e) {
      this.config[t] && this.config[t](e);
    }
  }]), t;
}(),
    Lt = ["number", "expDate", "cvc", "firstName"],
    Bt = function () {
  function t(e) {
    var n;
    It(this, t), Mt(this, "config", {}), Mt(this, "postMessageInstance", new Nt()), Mt(this, "hasCardName", !0), this.host = e.host || "", this.uuid = (n = new Date().getTime(), "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (t) {
      var e = (n + 16 * Math.random()) % 16 | 0;
      return n = Math.floor(n / 16), ("x" == t ? e : 3 & e | 8).toString(16);
    })), this.postMessageInstance.setUuid(this.uuid), this.postMessageInstance.setIframeHost(this.host), this.cardIframeInstance = new Tt(this.uuid);
  }

  var e, n;
  return St(t, [{
    key: "create",
    value: function value(t) {
      this.config = t, this.cardEventInstance = new Pt(t);
    }
  }, {
    key: "mount",
    value: function value(t) {
      var e = this,
          n = "string" == typeof t ? document.querySelector(t) : t;

      if (this.mountDom = n, this.cardIframeInstance.setParentDom(n), n) {
        this.hasCardName = !!n.querySelector('[data-pci="firstName"]');
        var r = this.hasCardName ? Lt : Lt.slice(0, 3);
        this.cardIframeInstance.renderIframe(this.host, r, this.config, this.postMessageInstance), this.cardEventInstance.setIframeLoaded(r), window.addEventListener("message", function (t) {
          t.data.uuid === e.uuid && e.cardEventInstance.handleEvent(t.data);
        });
      } else console.error("Can't find the mount dom");
    }
  }, {
    key: "setStyle",
    value: function value(t) {
      var e = t.type,
          n = t.fieldName,
          r = t.style;
      this.postMessageInstance.setStyle(r, e, n);
    }
  }, {
    key: "destroy",
    value: function value() {
      var t = this;
      this.mountDom && Lt.forEach(function (e) {
        return t.cardIframeInstance.unmountDom('[data-pci="'.concat(e, '"]'));
      });
    }
  }, {
    key: "validate",
    value: (e = Dt.mark(function t() {
      var e = this;
      return Dt.wrap(function (t) {
        for (;;) {
          switch (t.prev = t.next) {
            case 0:
              return t.abrupt("return", new Promise(function (t) {
                e.cardEventInstance.setValidateResolve(t), e.postMessageInstance.getValidate(e.hasCardName, "number");
              }));

            case 1:
            case "end":
              return t.stop();
          }
        }
      }, t);
    }), n = function n() {
      var t = this,
          n = arguments;
      return new Promise(function (r, i) {
        var o = e.apply(t, n);

        function a(t) {
          Et(o, r, i, a, c, "next", t);
        }

        function c(t) {
          Et(o, r, i, a, c, "throw", t);
        }

        a(void 0);
      });
    }, function () {
      return n.apply(this, arguments);
    })
  }, {
    key: "pay",
    value: function value(t) {
      var e = this,
          n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
      return new Promise(function (r, i) {
        e.cardEventInstance.setPayResolve(r), e.cardEventInstance.setPayReject(i), e.postMessageInstance.pay(t, e.hasCardName, n, "number");
      });
    }
  }, {
    key: "getCardBrand",
    value: function value() {
      var t = this;
      return new Promise(function (e) {
        t.cardEventInstance.setCardBrandResolve(e), t.postMessageInstance.getCardBrand("number");
      });
    }
  }]), t;
}();

var Qt = {
  splitReg: "!\\[[^\\]]+\\][\\\\]*\\([^)]+\\)",
  matchReg: /!\[([^\]]+)\]\(([^)]+)\)/,
  replaceReg: "(!\\[[^\\]]+\\])(\\\\+)(\\([^)]+\\))"
},
    Ft = {
  splitReg: "\\[[^\\]]+\\][\\\\]*\\([^)]+\\)",
  matchReg: /\[([^\]]+)\]\(([^)]+)\)/,
  replaceReg: "(\\[[^\\]]+\\])(\\\\+)(\\([^)]+\\))"
},
    Rt = function Rt(t) {
  var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "",
      n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
  return {
    tagName: t,
    content: e,
    property: n
  };
},
    zt = function zt(t, e, n, r) {
  return e + (n ? n.slice(1) : "") + r;
},
    Ut = function () {
  function t() {
    !function (t, e) {
      if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
    }(this, t);
  }

  var e;
  return (e = [{
    key: "parseToTagConfig",
    value: function value(t) {
      var e = [],
          n = Ft,
          r = Qt;
      if (!t || 0 !== t.indexOf("$RT$")) return [Rt("text", t)];
      t = t.slice("$RT$".length);
      var i = "(".concat(r.splitReg, ")|(").concat(n.splitReg, ")");
      return t.split(new RegExp(i)).filter(function (t) {
        return !!t;
      }).forEach(function (t) {
        var i;

        if (new RegExp(r.matchReg).test(t)) {
          var o = t.match(r.matchReg);
          i = Rt("img", "", {
            alt: o[1],
            src: o[2]
          });
        } else if (new RegExp(n.matchReg).test(t)) {
          var a = t.match(n.matchReg);
          i = Rt("a", a[1], {
            href: a[2],
            target: "_blank"
          });
        } else if (new RegExp(r.replaceReg).test(t)) {
          var c = t.replace(new RegExp(r.replaceReg, "g"), zt);
          i = Rt("text", c);
        } else if (new RegExp(n.replaceReg).test(t)) {
          var s = t.replace(new RegExp(n.replaceReg, "g"), zt);
          i = Rt("text", s);
        } else i = Rt("text", t);

        e.push(i);
      }), e;
    }
  }, {
    key: "parseToDom",
    value: function value(t) {
      var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "div",
          n = document.createElement(e);
      return t.forEach(function (t) {
        var e = document.createElement("text" === t.tagName ? "span" : t.tagName);
        e.textContent = t.content, t.property && Object.keys(t.property).forEach(function (n) {
          return e.setAttribute(n, t.property[n]);
        }), n.appendChild(e);
      }), n;
    }
  }, {
    key: "autoParseToDom",
    value: function value(t) {
      var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "div",
          n = this.parseToTagConfig(t);
      return this.parseToDom(n, e);
    }
  }]) && function (t, e) {
    for (var n = 0; n < e.length; n++) {
      var r = e[n];
      r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
    }
  }(t.prototype, e), t;
}(),
    Yt = "webpaymentsdk",
    Vt = new e(Yt, {
  performance: !1
});

function Wt(t, e, n) {
  var r = t.merchantId,
      i = t.countryCode,
      o = t.currency,
      a = t.paymentMethod,
      c = t.validateState,
      s = e,
      u = {
    merchantId: r,
    countryCode: i,
    currency: o,
    paymentMethod: a,
    pathname: window.location.pathname,
    sessionId: n,
    validateState: c,
    actionType: e
  };

  try {
    Vt.report(s, u);
  } catch (t) {
    Y.report(new Error(JSON.stringify({
      response: t
    })));
  }
}

Vt.init({
  version: "1.10.1",
  projectName: Yt,
  environment: "production"
});
vt('.payment-sdk-m-auto {\n  margin: auto;\n}\n\n.payment-sdk-mt-4 {\n  margin-top: 1rem;\n}\n\n.pci-container * {\n  margin: 0;\n  font-family: Helvetica;\n  font-style: normal;\n  font-weight: normal;\n}\n\n.pci-container {\n  margin: 0 auto;\n}\n\n.pci-content {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.pci-content-form {\n  position: relative;\n  flex: 0 1 100%;\n}\n\n.pci-content-loading .pci-input-container {\n  background-color: var(--input-font-color);\n  opacity: 0.05;\n  border-radius: var(--input-border-radius);\n  height: var(--input-height);\n}\n\n.pci-content-loading .pci-input-box,\n.pci-content-loading .pci-icon {\n  display: none;\n}\n\n.pci-dateAndCvc-box {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n}\n\n.pci-pc-style .pci-dateAndCvc-box .pci-input-container {\n  width: 50%;\n}\n\n.pci-dateAndCvc-box > .pci-input-container:first-child {\n  margin-right: var(--form-item-gutter);\n}\n\n.pci-input-container {\n  position: relative;\n  width: 100%;\n  margin-bottom: var(--form-item-gutter);\n  overflow: visible;\n  transition: all 0.2s linear;\n}\n\n.pci-input-box {\n  position: relative;\n  box-sizing: border-box;\n  overflow: hidden;\n  z-index: 1;\n  background-color: var(--input-background);\n  height: var(--input-height);\n  border-width: 1px;\n  border-style: solid;\n  border-color: var(--input-border-color);\n  border-radius: var(--input-border-radius);\n}\n\n.pci-input-box.pci-input-box-focus {\n  border-color: var(--input-focus-color);\n  box-shadow: 0 0 0 1px var(--input-focus-color);\n}\n\n.pci-input-box-not-empty .pci-input-label {\n  font-size: 10px;\n  transform: translateY(-9px);\n  transition: all 0.2s linear;\n}\n\n.pci-input-box-not-empty .pci-input-content {\n  transition: all 0.2s linear;\n  height: var(--input-height);\n}\n\n.pci-input-box-not-empty .pci-input-content input {\n  transition: all 0.2s linear;\n  padding: 20px 28px 0 16px;\n}\n\n.pci-input-valid-error-box .pci-input-box {\n  border-color: var(--input-error-border-color);\n  box-shadow: 0 0 0 1px var(--input-error-border-color);\n}\n\n.pci-input-content {\n  height: 100%;\n  background-color: transparent;\n}\n\n.pci-number-icon,\n.pci-firstName-icon,\n.pci-cvc-icon {\n  position: absolute;\n  top: calc(var(--input-height) / 2 - 16px / 2);\n  right: 16px;\n  width: 16px;\n  height: 16px;\n  z-index: 10;\n}\n\n.pci-input-label {\n  position: absolute;\n  top: calc(var(--input-height) / 2 - 16px / 2);\n  left: 16px;\n  font-size: 14px;\n  line-height: 16px;\n  color: var(--input-label-color);\n  pointer-events: none;\n  transition: all 0.2s linear;\n  white-space: nowrap;\n}\n\n.pci-number-brand-icon {\n  top: calc(var(--input-height) / 2 - 24px / 2);\n  right: 12px;\n  width: 38px;\n  height: 24px;\n}\n\n.pci-input-tip,\n.pci-error-tip {\n  height: 0;\n  font-size: 14px;\n  line-height: 16px;\n  overflow: hidden;\n  transition: all 0.2s linear;\n  margin-left: 1px;\n}\n\n.pci-error-tip {\n  color: var(--input-error-font-color);\n}\n\n.pci-error-tip.pci-input-valid-error,\n.pci-input-tip.pci-input-tip-show {\n  margin-top: var(--input-tip-gutter);\n}\n\n.pci-input-tip {\n  color: #959595;\n}\n\n.pci-card {\n  flex: 0 1 316px;\n  height: 176px;\n  padding: 24px 24px 0;\n  box-sizing: border-box;\n  background: linear-gradient(180deg, #cfcfcf 0%, #c4c3c3 100%);\n  box-shadow: inset 0px 0px 10px rgba(255, 255, 255, 0.25);\n  border-radius: 4px;\n}\n\n.pci-card-logo {\n  width: 64px;\n  height: 40px;\n  margin-bottom: 24px;\n  background: #ffffff;\n  opacity: 0.4;\n  border-radius: 2px;\n}\n\n.pci-card-number {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 24px;\n}\n\n.pci-card-number-dot-list {\n  width: 48px;\n  height: 6px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.pci-card-number-dot-item {\n  width: 6px;\n  height: 6px;\n  border-radius: 6px;\n  background-color: #fff;\n}\n\n.pci-card-nameAndexpDate {\n  display: flex;\n  justify-content: space-between;\n}\n\n.pci-card-name,\n.pci-card-expDate {\n  float: right;\n  text-align: right;\n}\n\n.pci-card-name p,\n.pci-card-expDate p {\n  margin: 0 0 8px 0;\n  font-size: 12px;\n  line-height: 14px;\n  color: rgba(255, 255, 255, 0.7);\n}\n\n.pci-card-name .pci-card-number-dot-list {\n  float: left;\n}\n\n.pci-card-expDate .pci-card-number-dot-list {\n  float: right;\n}\n\n.pci-footer {\n  text-indent: 20px;\n  font-size: 11px;\n  line-height: 16px;\n  color: rgba(30, 30, 30, 0.4);\n  background: url("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEwLjg3NzMgNS4zMzMzNEgxMC4xNTU3QzkuOTk4ODIgNS4zMzMzNCA5Ljg0OTU4IDUuNDA1MjYgOS43NTcyNyA1LjUyODUzTDcuMzM4NzMgOC43Mjc5TDYuMjQzMzEgNy4yNzc5MUM2LjE1MSA3LjE1NjEgNi4wMDMzIDcuMDgyNzIgNS44NDQ4NCA3LjA4MjcySDUuMTIzMjhDNS4wMjMyNyA3LjA4MjcyIDQuOTY0ODEgNy4xOTEzMyA1LjAyMzI3IDcuMjY5MTFMNi45NDAyNiA5LjgwNTEyQzYuOTg1NTQgOS44NjU0MiA3LjA0NTI0IDkuOTE0NTUgNy4xMTQ0MSA5Ljk0ODQ0QzcuMTgzNTcgOS45ODIzMyA3LjI2MDIxIDEwIDcuMzM3OTYgMTBDNy40MTU3MiAxMCA3LjQ5MjM1IDkuOTgyMzMgNy41NjE1MiA5Ljk0ODQ0QzcuNjMwNjggOS45MTQ1NSA3LjY5MDM4IDkuODY1NDIgNy43MzU2NyA5LjgwNTEyTDEwLjk3NTggNS41MTk3M0MxMS4wMzU4IDUuNDQxOTUgMTAuOTc3MyA1LjMzMzM0IDEwLjg3NzMgNS4zMzMzNFoiIGZpbGw9IiMzNUMwOEUiLz4KPHBhdGggZD0iTTIuNzUgMy40Njg4NUMyLjc1IDMuMzUxNjcgMi44MzEzOCAzLjI1MDIyIDIuOTQ1NzcgMy4yMjQ4TDcuOTQ1NzcgMi4xMTM2OUM3Ljk4MTQ5IDIuMTA1NzUgOC4wMTg1MSAyLjEwNTc1IDguMDU0MjMgMi4xMTM2OUwxMy4wNTQyIDMuMjI0OEMxMy4xNjg2IDMuMjUwMjIgMTMuMjUgMy4zNTE2NyAxMy4yNSAzLjQ2ODg1VjkuNTk2MzFDMTMuMjUgMTAuMDE0MiAxMy4wNDExIDEwLjQwNDUgMTIuNjkzNCAxMC42MzY0TDguMTM4NjcgMTMuNjcyOEM4LjA1NDcgMTMuNzI4OCA3Ljk0NTMgMTMuNzI4OCA3Ljg2MTMyIDEzLjY3MjhMMy4zMDY2MiAxMC42MzY0QzIuOTU4ODggMTAuNDA0NSAyLjc1IDEwLjAxNDMgMi43NSA5LjU5NjMxVjMuNDY4ODVaIiBzdHJva2U9IiMzNUMwOEUiIHN0cm9rZS13aWR0aD0iMS41Ii8+Cjwvc3ZnPgo=")\n    no-repeat left top/12px 14px;\n}\n\n.pci-footer a,\n.pci-footer a:hover,\n.pci-footer a:active {\n  color: #466c63;\n  text-decoration: none;\n}\n\n.pci-footer-tips {\n  word-break: break-word;\n}\n\n.pci-footer-tips img {\n  width: 20px;\n}\n\n.pci-footer-loading {\n  background: rgba(221, 221, 216, 0.3);\n  border-radius: 4px;\n  height: 10px;\n}\n\n.pci-footer-loading .pci-footer-tips {\n  display: none;\n}\n\n.pci-mobile-style {\n  padding: 0;\n  box-sizing: border-box;\n}\n\n/* 小屏幕不展示卡片 */\n\n.pci-mobile-style .pci-container,\n.pci-mobile-style {\n  max-width: 100%;\n  width: 100%;\n  margin: 0 auto;\n}\n\n.pci-mobile-style .pci-content-form {\n  flex: auto;\n}\n\n.pci-mobile-style .pci-bind-card-container {\n  width: 100%;\n}\n\n.pci-mobile-style .pci-name-box {\n  margin-bottom: 0;\n}\n\n.pci-mobile-style .pci-dateAndCvc-box {\n  display: block;\n}\n\n.pci-mobile-style .pci-input-box {\n  margin-bottom: 0;\n}\n\n.pci-mobile-style .pci-input-container {\n  width: 100%;\n}\n\n.pci-mobile-style .pci-dateAndCvc-box .pci-input-container {\n  margin-right: 0;\n}\n\n.pci-mobile-style .pci-card {\n  display: none;\n}\n\n@media (min-width: 640px) {\n}\n\n@media (min-width: 768px) {\n}\n\n@media (min-width: 1024px) {\n}\n\n@media (min-width: 1280px) {\n}\n', {});

var _t = "data:image/svg+xml,%3csvg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'%3e%3cpath fill-rule='evenodd' clip-rule='evenodd' d='M13.6 8C13.6 11.0928 11.0928 13.6 8 13.6C4.90721 13.6 2.4 11.0928 2.4 8C2.4 4.90721 4.90721 2.4 8 2.4C11.0928 2.4 13.6 4.90721 13.6 8ZM15 8C15 11.866 11.866 15 8 15C4.13401 15 1 11.866 1 8C1 4.13401 4.13401 1 8 1C11.866 1 15 4.13401 15 8ZM9.45298 7.94043C8.86649 8.2889 8.60666 8.62269 8.59923 9.33797C8.59563 9.68549 8.31985 9.94303 7.89582 9.94303C7.49737 9.94303 7.1924 9.68549 7.1924 9.33797C7.19612 8.05414 7.54504 7.66166 8.16865 7.27285C8.62522 6.98674 8.97785 6.66762 8.97785 6.1871C8.97785 5.67724 8.57325 5.34712 8.07214 5.34712C7.58587 5.34712 7.15624 5.63856 7.11445 6.26413C7.0902 6.62714 6.78059 6.98126 6.35721 6.98126C5.93369 6.98126 5.59998 6.61104 5.59998 6.26413C5.59998 4.80823 6.73212 4.09998 8.07956 4.09998C9.55321 4.09998 10.6 4.84826 10.6 6.13208C10.6 6.99407 10.1471 7.53328 9.45298 7.94043ZM7.92373 12.4033C8.39886 12.4033 8.81089 12.0109 8.8146 11.523C8.81089 11.0425 8.39886 10.65 7.92373 10.65C7.43375 10.65 7.02915 11.0425 7.03286 11.523C7.02915 12.0109 7.43375 12.4033 7.92373 12.4033Z' fill='%232C2C2C' fill-opacity='0.75'/%3e%3c/svg%3e",
    Ht = function () {
  function t(e) {
    i(this, t), c(this, "theme", {}), c(this, "DEFAULT_THEME", c({}, $.CreditCard, {
      inputBackground: "#fff",
      formItemGutter: "12px",
      inputHeight: "46px",
      cardNumberIcon: "data:image/svg+xml,%3csvg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'%3e%3cpath fill-rule='evenodd' clip-rule='evenodd' d='M7.99998 2.70002C6.70211 2.70002 5.64998 3.75216 5.64998 5.05002V5.79999H10.35V5.05002C10.35 3.75216 9.29784 2.70002 7.99998 2.70002ZM4.34998 5.05002V5.79999H4C2.89543 5.79999 2 6.69542 2 7.79999V12.8C2 13.9046 2.89543 14.8 4 14.8H12C13.1046 14.8 14 13.9046 14 12.8V7.79999C14 6.69542 13.1046 5.79999 12 5.79999H11.65V5.05002C11.65 3.03418 10.0158 1.40002 7.99998 1.40002C5.98414 1.40002 4.34998 3.03418 4.34998 5.05002ZM4 7.09999H12C12.3866 7.09999 12.7 7.41339 12.7 7.79999V12.8C12.7 13.1866 12.3866 13.5 12 13.5H4C3.6134 13.5 3.3 13.1866 3.3 12.8V7.79999C3.3 7.41339 3.6134 7.09999 4 7.09999ZM8.59998 10.5395C8.9587 10.332 9.20005 9.94419 9.20005 9.49999C9.20005 8.83725 8.66279 8.29999 8.00005 8.29999C7.33731 8.29999 6.80005 8.83725 6.80005 9.49999C6.80005 9.94413 7.04134 10.3319 7.39998 10.5394V11.9C7.39998 12.2314 7.6686 12.5 7.99998 12.5C8.33135 12.5 8.59998 12.2314 8.59998 11.9V10.5395Z' fill='%232C2C2C' fill-opacity='0.75'/%3e%3c/svg%3e",
      holderNameIcon: _t,
      securityCodeIcon: _t,
      inputBorderColor: "#dddddd",
      inputBorderRadius: "4px",
      inputFocusColor: "#276EAF",
      inputErrorBorderColor: "#F04949",
      inputErrorFontColor: "#F04949",
      inputTipGutter: "6px",
      inputLabelColor: "#616161",
      inputFontColor: "#2C2C2C"
    })), c(this, "CUSTOM_STYLE_LIST", ["inputBackground", "formItemGutter", "inputHeight", "inputTipGutter", "inputLabelColor", "inputFontColor", "inputBorderColor", "inputBorderRadius", "inputFocusColor", "inputErrorBorderColor", "inputErrorFontColor"]), this.theme = e || {};
  }

  return a(t, [{
    key: "get",
    value: function value(t, e) {
      var n,
          r,
          i,
          o = null === (n = this.theme) || void 0 === n || null === (r = n[t]) || void 0 === r ? void 0 : r[e];
      return o && "string" == typeof o ? o : null === (i = this.DEFAULT_THEME[t]) || void 0 === i ? void 0 : i[e];
    }
  }, {
    key: "getCreditCardThemeValue",
    value: function value(t) {
      return this.get($.CreditCard, t);
    }
  }, {
    key: "getCreditCardStyle",
    value: function value() {
      var t = this;
      return this.CUSTOM_STYLE_LIST.map(function (e) {
        var n = e.replace(/([A-Z])/g, "-$1").toLowerCase(),
            r = t.getCreditCardThemeValue(e);
        return "--".concat(n, ": ").concat(r, ";");
      }).join("");
    }
  }]), t;
}();

function Gt() {
  try {
    var _i = function _i(t, e) {
      try {
        return t.querySelectorAll(e);
      } catch (t) {
        return [];
      }
    };

    var _o = function _o(t, o) {
      for (var c, u = {
        selector: t,
        callback: o,
        elements: new WeakMap()
      }, l = _i(r, u.selector), p = 0; c = l[p++];) {
        u.elements.set(c, !0), u.callback.call(c, c);
      }

      n.push(u), e || (e = new MutationObserver(_s)).observe(r, {
        childList: !0,
        subtree: !0
      }), _a(u);
    };

    var _a = function _a(t, e) {
      var n,
          o = 0,
          a = [];

      try {
        e && e.matches(t.selector) && a.push(e);
      } catch (t) {}

      for (u && Array.prototype.push.apply(a, _i(e || r, t.selector)); n = a[o++];) {
        t.elements.has(n) || (t.elements.set(n, !0), t.callback.call(n, n));
      }
    };

    var _c = function _c(t) {
      for (var e, r = 0; e = n[r++];) {
        _a(e, t);
      }
    };

    var _s = function _s(t) {
      for (var e, n, r, i, o = 0; n = t[o++];) {
        for (r = n.addedNodes, e = 0; i = r[e++];) {
          1 === i.nodeType && _c(i);
        }
      }
    };

    var _l = function _l(t, e, n) {
      var r = Object.getOwnPropertyDescriptor(e, t);
      Object.defineProperty(n, t, r);
    };

    var _w = function _w(t) {
      if (!t.ieCP_polyfilled && !t.ieCP_elementSheet && t.sheet) {
        if (t.href) return function (t, e) {
          var n = new XMLHttpRequest();
          n.open("GET", t), n.overrideMimeType("text/css"), n.onload = function () {
            n.status >= 200 && n.status < 400 && e(n.responseText);
          }, n.send();
        }(t.href, function (e) {
          var n = _A(e);

          e !== n && _C(t, n);
        });

        var e = t.innerHTML,
            n = _A(e);

        e !== n && _C(t, n);
      }
    };

    var _A = function _A(t) {
      return t.replace(v, function (t, e, n, r, i, o) {
        return e + "-ie-" + (o ? "❗" : "") + r + ":" + i;
      }).replace(y, function (t, e, n, r) {
        return e + "-ieVar-" + (r ? "❗" : "") + n + "; " + n;
      });
    };

    var _x = function _x(t) {
      var e,
          n,
          r = t.cssText,
          i = r.match(m);

      if (i) {
        var o = [];

        for (e = 0; n = i[e++];) {
          var a = n.slice(7, -1);
          "❗" === a[0] && (a = a.substr(1)), o.push(a), p[a] || (p[a] = []), p[a].push(t);
        }
      }

      var c = r.match(g);

      if (c) {
        var s = {};

        for (e = 0; n = c[e++];) {
          var u = n.substr(4).split(":"),
              l = u[0],
              d = u[1];
          "❗" === l[0] && (l = l.substr(1)), s[l] = d;
        }
      }

      return {
        getters: o,
        setters: s
      };
    };

    var _C = function _C(t, e) {
      t.sheet.cssText = e, t.ieCP_polyfilled = !0;

      for (var n, r = t.sheet.rules, i = 0; n = r[i++];) {
        var o = _x(n.style);

        o.getters && _k(n.selectorText, o.getters), o.setters && _I(n.selectorText, o.setters);
        var a = n.parentRule && n.parentRule.media && n.parentRule.media.mediaText;
        a && (o.getters || o.setters) && matchMedia(a).addListener(function () {
          _B(document.documentElement);
        });
      }

      _S();
    };

    var _k = function _k(t, e) {
      _j(t), _o(_N(t), function (n) {
        _E(n, e, t), _T(n);
      });
    };

    var _E = function _E(t, e, n) {
      var r,
          i,
          o = 0,
          a = n.split(",");

      for (t.setAttribute("iecp-needed", !0), t.ieCPSelectors || (t.ieCPSelectors = {}); r = e[o++];) {
        for (i = 0; n = a[i++];) {
          var c = n.trim().split("::");
          t.ieCPSelectors[r] || (t.ieCPSelectors[r] = []), t.ieCPSelectors[r].push({
            selector: c[0],
            pseudo: c[1] ? "::" + c[1] : ""
          });
        }
      }
    };

    var _I = function _I(t, e) {
      _j(t), _o(_N(t), function (t) {
        _O(t, e);
      });
    };

    var _O = function _O(t, e) {
      for (var n in t.ieCP_setters || (t.ieCP_setters = {}), e) {
        t.ieCP_setters["--" + n] = 1;
      }

      _B(t);
    };

    var _S = function _S() {
      for (var t in p) {
        for (var e, n = p[t], r = 0; e = n[r++];) {
          if (!e.owningElement) {
            var i = e["-ieVar-" + t];
            if (i && "" !== (i = _F(getComputedStyle(document.documentElement), i))) try {
              e[t] = i;
            } catch (t) {}
          }
        }
      }
    };

    var _j = function _j(t) {
      for (var e in t = t.split(",")[0], M) {
        var n = t.split(":" + e);
        n.length > 1 && function () {
          var t = n[1].match(/^[^\s]*/),
              r = _N(n[0] + t),
              i = M[e];

          _o(r, function (t) {
            t.addEventListener(i.on, _Q), t.addEventListener(i.off, _Q);
          });
        }();
      }
    };

    var _N = function _N(t) {
      return t.replace(b, "").replace(":not()", "");
    };

    var _T = function _T(t) {
      d.add(t), h || (h = !0, requestAnimationFrame(function () {
        h = !1, f = !0, d.forEach(_L), d.clear(), setTimeout(function () {
          f = !1;
        });
      }));
    };

    var _L = function _L(t) {
      t.ieCP_unique || (t.ieCP_unique = ++P, t.classList.add("iecp-u" + t.ieCP_unique));
      var e = getComputedStyle(t),
          n = "";

      for (var r in t.runtimeStyle.cssText = "", t.ieCPSelectors) {
        var i = e["-ieVar-❗" + r],
            o = i || e["-ieVar-" + r];

        if (o) {
          var a = {},
              c = _F(e, o, a);

          i && (c += " !important");

          for (var s, u = 0; s = t.ieCPSelectors[r][u++];) {
            "%styleAttr" === s.selector && (t.style[r] = c), (i || !1 === a.allByRoot) && (s.pseudo ? n += s.selector + ".iecp-u" + t.ieCP_unique + s.pseudo + "{" + r + ":" + c + "}\n" : t.runtimeStyle[r] = c);
          }
        }
      }

      !function (t, e) {
        if (!t.ieCP_styleEl && e) {
          var n = document.createElement("style");
          n.ieCP_elementSheet = 1, document.head.appendChild(n), t.ieCP_styleEl = n;
        }

        t.ieCP_styleEl && (t.ieCP_styleEl.innerHTML = e);
      }(t, n);
    };

    var _B = function _B(t) {
      if (t) {
        t === document.documentElement && _S();
        var e = t.querySelectorAll("[iecp-needed]");
        t.hasAttribute && t.hasAttribute("iecp-needed") && _T(t);

        for (var n, r = 0; n = e[r++];) {
          _T(n);
        }
      }
    };

    var _Q = function _Q(t) {
      _B(t.target);
    };

    var _F = function _F(t, e, n) {
      return function (t, e) {
        for (var n, r, i = 0, o = null, a = 0, c = "", s = 0; n = t[s++];) {
          if ("(" === n && (++i, null === o && t[s - 4] + t[s - 3] + t[s - 2] === "var" && (o = i, c += t.substring(a, s - 4), a = s), t[s - 5] + t[s - 4] + t[s - 3] + t[s - 2] === "calc" && (r = i)), ")" === n && o === i) {
            var u = t.substring(a, s - 1).trim(),
                l = void 0,
                p = u.indexOf(",");
            -1 !== p && (l = u.slice(p + 1), u = u.slice(0, p)), c += e(u, l, r), a = s, o = null;
          }

          ")" === n && r === --i && (r = null);
        }

        return c + t.substring(a);
      }(e, function (e, r, i) {
        var o = t.getPropertyValue(e);
        return i && (o = o.replace(/^calc\(/, "(")), n && t.lastPropertyServedBy !== document.documentElement && (n.allByRoot = !1), "" === o && r && (o = _F(t, r, n)), o;
      });
    };

    var t = document.createElement("i");
    if (t.style.setProperty("--x", "y"), "y" === t.style.getPropertyValue("--x") || !t.msMatchesSelector) return;
    Element.prototype.matches || (Element.prototype.matches = Element.prototype.msMatchesSelector);
    var e,
        n = [],
        r = document;
    var u = !1;
    document.addEventListener("DOMContentLoaded", function () {
      u = !0;
    }), "classList" in Element.prototype || _l("classList", HTMLElement.prototype, Element.prototype), "innerHTML" in Element.prototype || _l("innerHTML", HTMLElement.prototype, Element.prototype), "runtimeStyle" in Element.prototype || _l("runtimeStyle", HTMLElement.prototype, Element.prototype), "sheet" in SVGStyleElement.prototype || Object.defineProperty(SVGStyleElement.prototype, "sheet", {
      get: function get() {
        for (var t, e = document.styleSheets, n = 0; t = e[n++];) {
          if (t.ownerNode === this) return t;
        }
      }
    });
    var p = {},
        d = new Set(),
        h = !1,
        f = !1,
        v = /([\s{;])(--([A-Za-z0-9-_]*)\s*:([^;!}{]+)(!important)?)(?=\s*([;}]|$))/g,
        y = /([{;]\s*)([A-Za-z0-9-_]+\s*:[^;}{]*var\([^!;}{]+)(!important)?(?=\s*([;}$]|$))/g,
        m = /-ieVar-([^:]+):/g,
        g = /-ie-([^};]+)/g,
        b = /:(hover|active|focus|target|visited|link|:before|:after|:first-letter|:first-line)/;
    _o("style:not([iecp-ignore])", _w), _o("link[rel=stylesheet]:not([iecp-ignore])", _w), _o("[ie-style]", function (t) {
      var e = _A("{" + t.getAttribute("ie-style")).substr(1);

      t.style.cssText += ";" + e;

      var n = _x(t.style);

      n.getters && _E(t, n.getters, "%styleAttr"), n.setters && _O(t, n.setters);
    });
    var M = {
      hover: {
        on: "mouseenter",
        off: "mouseleave"
      },
      focus: {
        on: "focusin",
        off: "focusout"
      },
      active: {
        on: "CSSActivate",
        off: "CSSDeactivate"
      }
    };
    var D = null;
    document.addEventListener("mousedown", function (t) {
      setTimeout(function () {
        if (t.target === document.activeElement) {
          var e = document.createEvent("Event");
          e.initEvent("CSSActivate", !0, !0), (D = t.target).dispatchEvent(e);
        }
      });
    }), document.addEventListener("mouseup", function () {
      if (D) {
        var t = document.createEvent("Event");
        t.initEvent("CSSDeactivate", !0, !0), D.dispatchEvent(t), D = null;
      }
    });
    var P = 0;
    var R = new MutationObserver(function (t) {
      if (!f) for (var e, n = 0; e = t[n++];) {
        "iecp-needed" !== e.attributeName && _B(e.target);
      }
    });
    setTimeout(function () {
      R.observe(document, {
        attributes: !0,
        subtree: !0
      });
    });
    var z = location.hash;
    addEventListener("hashchange", function (t) {
      var e = document.getElementById(location.hash.substr(1));

      if (e) {
        var n = document.getElementById(z.substr(1));
        _B(e), _B(n);
      } else _B(document);

      z = location.hash;
    });
    var U = Object.getOwnPropertyDescriptor(HTMLElement.prototype, "style"),
        V = U.get;
    U.get = function () {
      var t = V.call(this);
      return t.owningElement = this, t;
    }, Object.defineProperty(HTMLElement.prototype, "style", U);
    var W = getComputedStyle;

    window.getComputedStyle = function (t) {
      var e = W.apply(this, arguments);
      return e.computedFor = t, e;
    };

    var _ = CSSStyleDeclaration.prototype,
        H = _.getPropertyValue;

    _.getPropertyValue = function (t) {
      try {
        if (this.lastPropertyServedBy = !1, "-" !== (t = t.trim())[0] || "-" !== t[1]) return H.apply(this, arguments);
        var e = t.substr(2),
            n = "-ie-" + e,
            r = "-ie-❗" + e,
            i = this[r] || this[n];

        if (this.computedFor) {
          if (void 0 === i || G[i]) {
            if (G[i] || !X[t] || X[t].inherits) for (var o = this.computedFor.parentNode; o && 1 === o.nodeType;) {
              var a = getComputedStyle(o),
                  c = a[r] || a[n];

              if (void 0 !== c) {
                i = _F(this, c), this.lastPropertyServedBy = o;
                break;
              }

              o = o.parentNode;
            }
          } else i = _F(this, i), this.lastPropertyServedBy = this.computedFor;

          if ("initial" === i) return "";
        }

        return void 0 === i && X[t] && (i = X[t].initialValue), void 0 === i ? "" : i;
      } catch (t) {
        var s = t;
        throw s instanceof Object || (s = new Error(s)), s.isSent || (s.isSent = 1, Y.report(s)), s;
      }
    };

    var G = {
      inherit: 1,
      revert: 1,
      unset: 1
    },
        Z = _.setProperty;
    _.setProperty = function (t, e, n) {
      if ("-" !== t[0] || "-" !== t[1]) return Z.apply(this, arguments);
      var r = this.owningElement;
      r && (r.ieCP_setters || (r.ieCP_setters = {}), r.ieCP_setters[t] = 1), t = "-ie-" + ("important" === n ? "❗" : "") + t.substr(2), this.cssText += "; " + t + ":" + e + ";", r && _B(r);
    }, window.CSS || (window.CSS = {});
    var X = {};

    CSS.registerProperty = function (t) {
      X[t.name] = t;
    };
  } catch (t) {
    var J = t;
    throw J instanceof Object || (J = new Error(J)), J.isSent || (J.isSent = 1, Y.report(J)), J;
  }
}

var Zt = ["fieldName"];

function Xt(t, e) {
  var n = Object.keys(t);

  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(t);
    e && (r = r.filter(function (e) {
      return Object.getOwnPropertyDescriptor(t, e).enumerable;
    })), n.push.apply(n, r);
  }

  return n;
}

function Jt(t) {
  for (var e = 1; e < arguments.length; e++) {
    var n = null != arguments[e] ? arguments[e] : {};
    e % 2 ? Xt(Object(n), !0).forEach(function (e) {
      c(t, e, n[e]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : Xt(Object(n)).forEach(function (e) {
      Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
    });
  }

  return t;
}

var Kt = {
  number: "cardNumberIcon",
  cvc: "securityCodeIcon",
  firstName: "holderNameIcon"
},
    qt = function () {
  function e(t) {
    var n = this;

    try {
      i(this, e), c(this, "paymentMethod", void 0), c(this, "channelId", void 0), c(this, "language", void 0), c(this, "hasTipsArray", void 0), c(this, "pciSdk", void 0), c(this, "theme", void 0), c(this, "validateResult", {}), c(this, "cardBrand", void 0), c(this, "supportCardBrands", void 0), c(this, "isSupportCardBrand", void 0), c(this, "memoryResolve", void 0), c(this, "paymentInitData", void 0), c(this, "isPc", void 0), c(this, "container", void 0), c(this, "uuid", void 0), c(this, "insertLanguage", function (t) {
        try {
          var e, r;
          n.language = t, n.hasTipsArray = [];
          var i = t.formItems;

          if (Object.keys(i).forEach(function (e) {
            var r = n.container.querySelector("#pci-input-".concat(e, "-label")),
                o = n.container.querySelector("#pci-input-".concat(e, "-container"));

            if (r.textContent = t.formItems[e].labelTitle, i[e].tips && n.hasTipsArray.push({
              key: e,
              content: i[e].tips
            }), n.validateResult[e] = {
              isValid: !1,
              isEmpty: !0
            }, i[e].tips) {
              var a = n.theme.getCreditCardThemeValue(Kt[e]);
              dt({
                content: "div",
                props: {
                  id: "pci-".concat(e, "-icon"),
                  "class": "pci-icon pci-".concat(e, "-icon")
                },
                children: a ? {
                  content: "img",
                  props: {
                    src: a
                  }
                } : null
              }, o);
            }

            "firstName" === e && (n.container.querySelector("#pci-input-name-tip").textContent = t.pleaseEnterNameOnCardOrBusinessName);
          }), n.hasTipsArray.length > 0) {
            var o = new yt();
            n.hasTipsArray.forEach(function (t) {
              var e = n.container.querySelector("#pci-".concat(t.key, "-icon"));
              o.mount(e, t.content);
            });
          }

          var a,
              c = "".concat((null == t || null === (e = t.content) || void 0 === e || null === (r = e.creditCard) || void 0 === r ? void 0 : r.serviceTips) || "").concat((null == t ? void 0 : t.footer) || ""),
              s = new Ut();
          if (c) null === (a = n.container.querySelector(".pci-footer-tips")) || void 0 === a || a.appendChild(s.autoParseToDom(c));
          return n.pciSdk.mount(".pci-content-form-".concat(n.uuid)), new Promise(function (t) {
            n.memoryResolve = t;
          });
        } catch (t) {
          var u = t;
          throw u instanceof Object || (u = new Error(u)), u.isSent || (u.isSent = 1, Y.report(u)), u;
        }
      }), c(this, "needShowPcStyle", function (t) {
        n.isPc = t;
        var e = n.container.querySelector("#pci-container");

        if (e) {
          var r = e.getAttribute("class");
          r = r.replace(/(\s*pci-mobile-style)|(\s*pci-pc-style)/g, ""), r += " ".concat(t ? "pci-pc-style" : "pci-mobile-style"), e.setAttribute("class", r);
          ["number", "firstName", "expDate", "cvc"].forEach(function (t) {
            var e,
                r = null === (e = n.container) || void 0 === e ? void 0 : e.querySelector("#pci-".concat(t, "-error"));

            if (r) {
              var i = null == r ? void 0 : r.textContent,
                  o = null == r ? void 0 : r.parentElement;
              i && o && (o.style.height = "".concat(r.offsetHeight, "px"));
            }
          });
        }
      }), c(this, "createErrorDom", function (t) {
        return {
          content: "div",
          props: {
            "class": "pci-error-tip"
          },
          children: {
            content: "div",
            props: {
              id: "pci-".concat(t, "-error")
            }
          }
        };
      }), c(this, "handleFocusInput", function (t) {
        try {
          var e = t.fieldName,
              r = t.isEmpty,
              i = t.isFocus,
              o = t.isValid,
              a = n.container.querySelector("#pci-input-".concat(e, "-content")).parentElement,
              c = a.getAttribute("class"),
              s = !1;
          n.validateResult[e].isValid = o, !r && !i || c.includes("pci-input-box-not-empty") ? !i && r && c.includes("pci-input-box-not-empty") && (c = c.replace(" pci-input-box-not-empty", "")) : c += " pci-input-box-not-empty", i ? (n.allBlur(), c.includes("pci-input-box-focus") || (c += " pci-input-box-focus"), n.setError(e, ""), s = !0) : (s = !1, c = c.replace(" pci-input-box-focus", "")), "firstName" === e && n.handleShowOrHideDom({
            id: "pci-input-name-tip",
            type: "tip",
            className: "pci-input-tip-show",
            show: s
          });
          var u = "";

          if (!i && !r) {
            var l = n.validateResult[e].isValid,
                p = !1;
            l ? (p = !0, n.isSupportCardBrand || "number" !== e || (p = !1, u = n.language.cardIsNotSupported)) : u = n.language.formItems[e].errorTips, p ? n.setError(e, "") : n.setError(e, u);
          }

          a.setAttribute("class", c);
        } catch (t) {
          var d = t;
          throw d instanceof Object || (d = new Error(d)), d.isSent || (d.isSent = 1, Y.report(d)), d;
        }
      }), c(this, "handleShowOrHideDom", function (t) {
        var e = t.id,
            r = t.className,
            i = t.type,
            o = t.content,
            a = t.show;

        try {
          var c = n.container.querySelector("#".concat(e));
          if (!c) return null;
          var s = c.parentElement,
              u = s.parentElement,
              l = s.getAttribute("class"),
              p = u.getAttribute("class");
          "error" === i && (c.textContent = o), !o && !0 !== a || l.includes("".concat(r)) ? "" !== o && !1 !== a || !l.includes("".concat(r)) || (s.style.height = "0px", l = l.replace(" ".concat(r), ""), "error" === i && (p = p.replace(" pci-input-valid-error-box", ""))) : (l += " ".concat(r), s.style.height = "".concat(c.offsetHeight, "px"), "error" === i && (p += " pci-input-valid-error-box")), s.setAttribute("class", l), "error" === i && u.setAttribute("class", p);
        } catch (t) {
          var d = t;
          throw d instanceof Object || (d = new Error(d)), d.isSent || (d.isSent = 1, Y.report(d)), d;
        }
      }), c(this, "onBrandChange", function (t) {
        n.cardBrand = t.brand, n.cardBrand && n.supportCardBrands.length && -1 === n.supportCardBrands.indexOf(n.cardBrand) ? n.isSupportCardBrand = !1 : n.isSupportCardBrand = !0, n.setBrandIcon(n.cardBrand);
      }), c(this, "onFieldValidChange", function (t) {
        var e = t.fieldName,
            r = l(t, Zt);
        n.validateResult[e] = Jt(Jt({}, n.validateResult[e]), r), t.isEmpty && n.setError(e, "");
      }), c(this, "pciSdkInit", function () {
        try {
          n.memoryResolve(!0);
          var t = n.container.querySelector("#pci-content-form"),
              e = t.getAttribute("class").replace(" pci-content-loading", "");
          t.setAttribute("class", e);
          var r = n.container.querySelector(".pci-footer"),
              i = r.getAttribute("class").replace(" pci-footer-loading", "");
          r.setAttribute("class", i);
          ["number", "firstName", "expDate", "cvc"].forEach(function (t) {
            n.pciSdk.setStyle({
              type: "base",
              fieldName: t,
              style: {
                padding: "20px 28px 0 16px",
                color: n.theme.getCreditCardThemeValue("inputFontColor")
              }
            });
          }), console.log("pciSdk Init 完成");
        } catch (t) {
          var o = t;
          throw o instanceof Object || (o = new Error(o)), o.isSent || (o.isSent = 1, Y.report(o)), o;
        }
      }), this.paymentInitData = t, this.paymentMethod = t.paymentMethod, this.channelId = t.channelId, this.uuid = function () {
        var t = new Date().getTime();
        return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (e) {
          var n = (t + 16 * Math.random()) % 16 | 0;
          return t = Math.floor(t / 16), ("x" == e ? n : 3 & n | 8).toString(16);
        });
      }(), this.pciSdk = new Bt({
        host: t.host
      }), this.theme = new Ht(t.theme), this.supportCardBrands = [], this.pciSdk.create({
        placeholder: {},
        onInit: this.pciSdkInit,
        onFocus: this.handleFocusInput,
        onBrandChange: this.onBrandChange,
        onFieldValidChange: this.onFieldValidChange
      });
    } catch (t) {
      var r = t;
      throw r instanceof Object || (r = new Error(r)), r.isSent || (r.isSent = 1, Y.report(r)), r;
    }
  }

  var n, o, s;
  return a(e, [{
    key: "render",
    value: (s = r(u.mark(function t(e) {
      var n;
      return u.wrap(function (t) {
        for (;;) {
          switch (t.prev = t.next) {
            case 0:
              this.container = e, n = window.CSS && window.CSS.supports && window.CSS.supports("(--foo: red)"), e.setAttribute("ontouchstart", ""), this.mutationObserver(), dt({
                content: "div",
                props: {
                  id: "pci-container",
                  "class": "pci-container ".concat(this.isPc ? "pci-pc-style" : "pci-mobile-style"),
                  style: n ? this.theme.getCreditCardStyle() : void 0,
                  "ie-style": n ? void 0 : this.theme.getCreditCardStyle()
                },
                children: [{
                  content: "div",
                  props: {
                    "class": "pci-content"
                  },
                  children: {
                    content: "div",
                    props: {
                      "class": "pci-content-form pci-content-loading pci-content-form-".concat(this.uuid),
                      id: "pci-content-form"
                    },
                    children: this.createFormItemsDom()
                  }
                }, {
                  content: "div",
                  props: {
                    "class": "pci-footer pci-footer-loading",
                    id: "pci-footer"
                  },
                  children: {
                    content: "div",
                    props: {
                      "class": "pci-footer-tips"
                    }
                  }
                }]
              }, e), n ? console.log("Support css variables") : (console.log("NOT support css variables"), Gt());

            case 7:
            case "end":
              return t.stop();
          }
        }
      }, t, this);
    })), function (t) {
      return s.apply(this, arguments);
    })
  }, {
    key: "createFormItemsDom",
    value: function value() {
      try {
        var t = !!tt[this.paymentInitData.channelId],
            e = this.createFormItem("number"),
            n = t ? null : this.createFormItem("firstName"),
            r = this.createFormItem("expDate"),
            i = this.createFormItem("cvc"),
            o = [e, n, {
          content: "div",
          props: {
            "class": "".concat(t ? "" : "pci-dateAndCvc-box")
          },
          children: [r, i]
        }];
        return t && o.splice(1, 1), o;
      } catch (t) {
        var a = t;
        throw a instanceof Object || (a = new Error(a)), a.isSent || (a.isSent = 1, Y.report(a)), a;
      }
    }
  }, {
    key: "createFormItem",
    value: function value(t) {
      var e = {
        content: "div",
        props: {
          "class": "pci-input-container",
          id: "pci-input-".concat(t, "-container")
        },
        children: [{
          content: "div",
          props: {
            "class": "pci-input-box"
          },
          children: [{
            content: "label",
            props: {
              "class": "pci-input-label",
              id: "pci-input-".concat(t, "-label")
            }
          }, {
            content: "div",
            props: {
              "data-pci": t,
              "class": "pci-input-content",
              id: "pci-input-".concat(t, "-content")
            }
          }]
        }]
      };

      if ("firstName" === t) {
        var n = this.createNameEnterTipDom();
        e.children.push(n);
      }

      var r = this.createErrorDom(t);
      return e.children.push(r), e;
    }
  }, {
    key: "createNameEnterTipDom",
    value: function value() {
      return {
        content: "div",
        props: {
          "class": "pci-input-tip"
        },
        children: {
          content: "div",
          props: {
            id: "pci-input-name-tip"
          }
        }
      };
    }
  }, {
    key: "setError",
    value: function value(t, e) {
      var n = "pci-".concat(t, "-error");
      this.handleShowOrHideDom({
        id: n,
        type: "error",
        className: "pci-input-valid-error",
        content: e
      });
    }
  }, {
    key: "allBlur",
    value: function value() {
      document.querySelectorAll(".pci-input-box-focus").forEach(function (t) {
        t.classList.remove("pci-input-box-focus");
      });
    }
  }, {
    key: "validate",
    value: (o = r(u.mark(function e() {
      var n,
          r,
          i = this;
      return u.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              if (n = !0, Object.keys(this.validateResult).forEach(function (t) {
                var e = i.validateResult[t],
                    r = "";
                !e.isEmpty && e.isValid || (r = i.language.formItems[t].errorTips, n = !1), i.setError(t, r);
              }), this.cardBrand) {
                e.next = 6;
                break;
              }

              return e.next = 5, this.pciSdk.getCardBrand();

            case 5:
              this.cardBrand = e.sent;

            case 6:
              if (this.validateResult.number.isValid && this.cardBrand && this.supportCardBrands.length && -1 === this.supportCardBrands.indexOf(this.cardBrand) && (this.isSupportCardBrand = !1, n = !1, r = this.language.cardIsNotSupported, this.setError("number", r), Wt({
                pvId: t,
                validateState: "".concat(n, "_").concat(this.cardBrand)
              }, "validate_card", null)), !n) {
                e.next = 11;
                break;
              }

              return e.next = 10, this.pciSdk.validate();

            case 10:
              n = e.sent;

            case 11:
              return e.abrupt("return", n);

            case 12:
            case "end":
              return e.stop();
          }
        }
      }, e, this);
    })), function () {
      return o.apply(this, arguments);
    })
  }, {
    key: "pay",
    value: (n = r(u.mark(function t(e, n) {
      var r, i;
      return u.wrap(function (t) {
        for (;;) {
          switch (t.prev = t.next) {
            case 0:
              return t.prev = 0, o = void 0, a = void 0, c = void 0, s = void 0, u = void 0, l = void 0, p = void 0, d = void 0, h = void 0, o = {}, a = window.navigator, c = a.userAgent, s = a.language, u = window.screen, l = u.colorDepth, p = u.width, d = u.height, h = window.navigator.javaEnabled().toString(), o.client = {
                transactionWebSite: window.location.href,
                javaEnabled: h,
                colorDepth: l.toString(),
                screenHeight: p.toString(),
                screenWidth: d.toString(),
                timeZoneOffset: new Date().getTimezoneOffset().toString(),
                accept: "application/json",
                userAgent: c,
                language: s
              }, r = o, t.next = 4, this.pciSdk.pay(e, Jt({
                paymentMethod: this.paymentMethod
              }, r));

            case 4:
              return i = t.sent, t.abrupt("return", Ct(i, n));

            case 8:
              return t.prev = 8, t.t0 = t["catch"](0), 400 === t.t0.statusCode && this.getErrorFromServer(t.t0.data), t.abrupt("return", Ct(t.t0));

            case 12:
            case "end":
              return t.stop();
          }
        }

        var o, a, c, s, u, l, p, d, h;
      }, t, this, [[0, 8]]);
    })), function (t, e) {
      return n.apply(this, arguments);
    })
  }, {
    key: "setSupportCardBrands",
    value: function value(t) {
      this.supportCardBrands = t;
    }
  }, {
    key: "getErrorFromServer",
    value: function value(t) {
      var e = "",
          n = "";

      switch (t.code) {
        case "4455":
          e = "number", n = this.language.pleaseEnterValidCardNumber;
          break;

        case "3001":
          e = "number", n = this.language.pleaseChangeAnotherCard;
          break;

        case "4459":
          e = "expDate", n = this.language.pleaseEnterExpired;
          break;

        case "4453":
          e = "cvc", n = this.language.pleaseEnterCVV;
      }

      n && (this.setError(e, n), this.validateResult[e].isValid = !1);
    }
  }, {
    key: "mutationObserver",
    value: function value() {
      var t = this,
          e = this.paymentInitData.needAdaptive,
          n = void 0 === e || e,
          r = "number" == typeof n ? n : 600;
      this.isPc = this.container.offsetWidth >= r;
      var i = null;
      if (!n && 0 !== n) return null;
      window.addEventListener("resize", function () {
        i && (clearTimeout(i), i = null), i = setTimeout(function () {
          var e = getComputedStyle(t.container).getPropertyValue("width").replace("px", "");
          t.needShowPcStyle(Number(e) > r);
        }, 200);
      });
    }
  }, {
    key: "setBrandIcon",
    value: function value(t) {
      var e = this.container.querySelector("#pci-number-icon"),
          n = e.querySelector("img"),
          r = e.querySelector(".pci-tooltip-wrap"),
          i = this.paymentInitData.host;

      if (t) {
        var o = "".concat(i || "https://cashiers.myshopline.com", "/payment-sdk/assets/image/").concat(encodeURIComponent(t), ".png");
        n.setAttribute("src", o), e.classList.add("pci-number-brand-icon", "hidden"), setTimeout(function () {
          e.classList.remove("hidden");
        }, 300), r.style.display = "none";
      } else {
        var a = this.theme.getCreditCardThemeValue(Kt.number);
        n.setAttribute("src", a), e.classList.remove("pci-number-brand-icon"), r.removeAttribute("style");
      }
    }
  }]), e;
}();

function $t(t, e) {
  (null == e || e > t.length) && (e = t.length);

  for (var n = 0, r = new Array(e); n < e; n++) {
    r[n] = t[n];
  }

  return r;
}

function te(t, e) {
  return function (t) {
    if (Array.isArray(t)) return t;
  }(t) || function (t, e) {
    var n = null == t ? null : "undefined" != typeof Symbol && t[Symbol.iterator] || t["@@iterator"];

    if (null != n) {
      var r,
          i,
          o = [],
          a = !0,
          c = !1;

      try {
        for (n = n.call(t); !(a = (r = n.next()).done) && (o.push(r.value), !e || o.length !== e); a = !0) {
          ;
        }
      } catch (t) {
        c = !0, i = t;
      } finally {
        try {
          a || null == n["return"] || n["return"]();
        } finally {
          if (c) throw i;
        }
      }

      return o;
    }
  }(t, e) || function (t, e) {
    if (t) {
      if ("string" == typeof t) return $t(t, e);
      var n = Object.prototype.toString.call(t).slice(8, -1);
      return "Object" === n && t.constructor && (n = t.constructor.name), "Map" === n || "Set" === n ? Array.from(t) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? $t(t, e) : void 0;
    }
  }(t, e) || function () {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }();
}

function ee(t, e) {
  var n = Object.keys(t);

  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(t);
    e && (r = r.filter(function (e) {
      return Object.getOwnPropertyDescriptor(t, e).enumerable;
    })), n.push.apply(n, r);
  }

  return n;
}

function ne(t) {
  for (var e = 1; e < arguments.length; e++) {
    var n = null != arguments[e] ? arguments[e] : {};
    e % 2 ? ee(Object(n), !0).forEach(function (e) {
      c(t, e, n[e]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : ee(Object(n)).forEach(function (e) {
      Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
    });
  }

  return t;
}

function re() {
  return ie.apply(this, arguments);
}

function ie() {
  return (ie = r(u.mark(function t() {
    var e,
        n,
        r,
        i,
        o,
        a,
        c,
        s,
        l,
        p,
        d,
        h = arguments;
    return u.wrap(function (t) {
      for (;;) {
        switch (t.prev = t.next) {
          case 0:
            return e = h.length > 0 && void 0 !== h[0] ? h[0] : "en", n = h.length > 1 ? h[1] : void 0, r = h.length > 2 && void 0 !== h[2] ? h[2] : "https://cashiers.myshopline.com", t.prev = 3, i = [["cardNumber", "number"], ["firstName", "firstName"], ["expiryDate", "expDate"], ["cvc", "cvc"]], a = {}, c = (o = "string" == typeof e ? {
              extend: e
            } : e).formItems, s = void 0 === c ? {} : c, t.next = 10, G.get("".concat(r, "/payment-sdk/assets/i18n/").concat(o.extend, ".json?hash=1.3"));

          case 10:
            return l = t.sent, p = l.data.formItems, i.forEach(function (t) {
              var e = te(t, 2),
                  r = e[0],
                  i = e[1];
              (n || "firstName" !== r) && (a[i] = ne(ne({}, p[r]), s[r]));
            }), o = ne(ne(ne({}, l.data), o), {}, {
              formItems: a
            }), t.abrupt("return", o);

          case 17:
            throw t.prev = 17, t.t0 = t["catch"](3), (d = t.t0) instanceof Object || (d = new Error(d)), d.isSent || (d.isSent = 1, Y.report(d)), d;

          case 23:
          case "end":
            return t.stop();
        }
      }
    }, t, null, [[3, 17]]);
  }))).apply(this, arguments);
}

function oe(t, e) {
  var n = Object.keys(t);

  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(t);
    e && (r = r.filter(function (e) {
      return Object.getOwnPropertyDescriptor(t, e).enumerable;
    })), n.push.apply(n, r);
  }

  return n;
}

function ae(t) {
  for (var e = 1; e < arguments.length; e++) {
    var n = null != arguments[e] ? arguments[e] : {};
    e % 2 ? oe(Object(n), !0).forEach(function (e) {
      c(t, e, n[e]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : oe(Object(n)).forEach(function (e) {
      Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
    });
  }

  return t;
}

var ce = function () {
  function t(e, n) {
    i(this, t), c(this, "initData", void 0), c(this, "containerElement", void 0), c(this, "pciUiInstance", void 0), this.initData = e, n && (this.containerElement = n);
  }

  var e, n, o, s;
  return a(t, [{
    key: "validate",
    value: (s = r(u.mark(function t() {
      return u.wrap(function (t) {
        for (;;) {
          switch (t.prev = t.next) {
            case 0:
              return t.next = 2, this.pciUiInstance.validate();

            case 2:
              return t.abrupt("return", t.sent);

            case 3:
            case "end":
              return t.stop();
          }
        }
      }, t, this);
    })), function () {
      return s.apply(this, arguments);
    })
  }, {
    key: "pay",
    value: (o = r(u.mark(function t(e, n) {
      return u.wrap(function (t) {
        for (;;) {
          switch (t.prev = t.next) {
            case 0:
              return t.next = 2, this.pciUiInstance.pay(e, n);

            case 2:
              return t.abrupt("return", t.sent);

            case 3:
            case "end":
              return t.stop();
          }
        }
      }, t, this);
    })), function (t, e) {
      return o.apply(this, arguments);
    })
  }, {
    key: "render",
    value: (n = r(u.mark(function t(e) {
      var n;
      return u.wrap(function (t) {
        for (;;) {
          switch (t.prev = t.next) {
            case 0:
              if (!(!e && !this.containerElement || e && this.containerElement)) {
                t.next = 2;
                break;
              }

              return t.abrupt("return");

            case 2:
              return this.containerElement = e, this.pciUiInstance = new qt(ae({}, this.initData)), t.next = 6, this.pciUiInstance.render(e);

            case 6:
              return t.next = 8, re(this.initData.language, !tt[this.initData.channelId], this.initData.host);

            case 8:
              return n = t.sent, t.next = 11, this.pciUiInstance.insertLanguage(n);

            case 11:
              return t.abrupt("return", t.sent);

            case 12:
            case "end":
              return t.stop();
          }
        }
      }, t, this);
    })), function (t) {
      return n.apply(this, arguments);
    })
  }, {
    key: "setSupportCardBrands",
    value: function value(t) {
      this.pciUiInstance.setSupportCardBrands(t);
    }
  }, {
    key: "destroy",
    value: function value() {
      this.containerElement.innerHTML = "", this.pciUiInstance = null;
    }
  }, {
    key: "needRenderWidget",
    value: (e = r(u.mark(function t() {
      return u.wrap(function (t) {
        for (;;) {
          switch (t.prev = t.next) {
            case 0:
              return t.abrupt("return", !0);

            case 1:
            case "end":
              return t.stop();
          }
        }
      }, t);
    })), function () {
      return e.apply(this, arguments);
    })
  }]), t;
}(),
    se = function () {
  function t(e, n) {
    var o = this;
    i(this, t), c(this, "container", void 0), c(this, "initData", void 0), c(this, "paymentMethodInfo", void 0), c(this, "getLanguageObj", r(u.mark(function t() {
      var e, n, r, i;
      return u.wrap(function (t) {
        for (;;) {
          switch (t.prev = t.next) {
            case 0:
              return e = o.initData, n = e.language, r = e.host, t.next = 3, re(n, !1, r);

            case 3:
              return i = t.sent, t.abrupt("return", i);

            case 5:
            case "end":
              return t.stop();
          }
        }
      }, t);
    }))), this.initData = e, this.paymentMethodInfo = n;
  }

  var e;
  return a(t, [{
    key: "getImageElement",
    value: function value() {
      return this.paymentMethodInfo.image ? {
        content: "img",
        props: {
          "class": "payment-sdk-m-auto",
          src: this.paymentMethodInfo.image
        }
      } : null;
    }
  }, {
    key: "getTextElement",
    value: function value(t) {
      return t ? {
        content: "div",
        props: {
          "class": this.paymentMethodInfo.image ? "payment-sdk-mt-4" : ""
        },
        children: t
      } : null;
    }
  }, {
    key: "render",
    value: (e = r(u.mark(function t(e) {
      var n, r, i, o;
      return u.wrap(function (t) {
        for (;;) {
          switch (t.prev = t.next) {
            case 0:
              return t.next = 2, this.getLanguageObj();

            case 2:
              if (n = t.sent, r = this.paymentMethodInfo || {}, i = r.image, o = r.description, i || o) {
                t.next = 6;
                break;
              }

              return t.abrupt("return");

            case 6:
              this.container = e, dt({
                content: "div",
                props: {
                  "class": "flex flex-col"
                },
                children: [this.getImageElement(), this.getTextElement(n[o])]
              }, e);

            case 9:
            case "end":
              return t.stop();
          }
        }
      }, t, this);
    })), function (t) {
      return e.apply(this, arguments);
    })
  }]), t;
}(),
    ue = function () {
  function t(e) {
    i(this, t), c(this, "initData", void 0), c(this, "containerElement", void 0), c(this, "paymentMethodInfo", void 0), c(this, "simpleUI", void 0), this.initData = e;
  }

  var e, n, o, s;
  return a(t, [{
    key: "validate",
    value: (s = r(u.mark(function t() {
      return u.wrap(function (t) {
        for (;;) {
          switch (t.prev = t.next) {
            case 0:
              return t.abrupt("return", !0);

            case 1:
            case "end":
              return t.stop();
          }
        }
      }, t);
    })), function () {
      return s.apply(this, arguments);
    })
  }, {
    key: "setPaymentMethodInfo",
    value: function value(t) {
      this.paymentMethodInfo = t;
    }
  }, {
    key: "render",
    value: (o = r(u.mark(function t(e) {
      return u.wrap(function (t) {
        for (;;) {
          switch (t.prev = t.next) {
            case 0:
              if (e || this.containerElement) {
                t.next = 2;
                break;
              }

              return t.abrupt("return");

            case 2:
              e && (this.containerElement = e), this.simpleUI = new se(this.initData, this.paymentMethodInfo), this.simpleUI.render(this.containerElement);

            case 5:
            case "end":
              return t.stop();
          }
        }
      }, t, this);
    })), function (t) {
      return o.apply(this, arguments);
    })
  }, {
    key: "pay",
    value: (n = r(u.mark(function t(e, n) {
      return u.wrap(function (t) {
        for (;;) {
          switch (t.prev = t.next) {
            case 0:
              return t.abrupt("return", At(e, n, this.initData.paymentMethod));

            case 1:
            case "end":
              return t.stop();
          }
        }
      }, t, this);
    })), function (t, e) {
      return n.apply(this, arguments);
    })
  }, {
    key: "destroy",
    value: function value() {
      this.containerElement && (this.containerElement.innerHTML = ""), this.simpleUI && (this.simpleUI = null);
    }
  }, {
    key: "needRenderWidget",
    value: (e = r(u.mark(function t() {
      return u.wrap(function (t) {
        for (;;) {
          switch (t.prev = t.next) {
            case 0:
              return t.abrupt("return", !0);

            case 1:
            case "end":
              return t.stop();
          }
        }
      }, t);
    })), function () {
      return e.apply(this, arguments);
    })
  }]), t;
}();

vt(".paypal-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n.paypal-container .paypal-img {\n  width: 192px;\n  height: 107px;\n  margin-bottom: 32px;\n}\n\n.paypal-container .paypal-tips {\n  font-size: 12px;\n  line-height: 18px;\n  text-align: center;\n  color: #959595;\n  font-family: Helvetica Neue;\n}\n", {});

var le = function () {
  function t() {
    i(this, t), c(this, "container", void 0);
  }

  return a(t, [{
    key: "render",
    value: function value(t) {
      this.container = t;
      dt({
        content: "div",
        props: {
          "class": "paypal-container"
        },
        children: [{
          content: "div",
          props: {
            "class": "paypal-img"
          },
          children: {
            content: "img",
            props: {
              src: "data:image/png;base64,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"
            }
          }
        }, {
          content: "div",
          props: {
            "class": "paypal-tips"
          },
          children: "After clicking “Complete order”, you will be redirected to PayPal to complete your purchase securely."
        }]
      }, t);
    }
  }]), t;
}(),
    pe = function () {
  function t(e, n) {
    i(this, t), c(this, "initData", void 0), c(this, "containerElement", void 0), c(this, "paypalUiInstance", void 0), this.initData = e, n && (this.containerElement = n);
  }

  var e, n, o, s;
  return a(t, [{
    key: "render",
    value: (s = r(u.mark(function t(e) {
      return u.wrap(function (t) {
        for (;;) {
          switch (t.prev = t.next) {
            case 0:
              if (e || this.containerElement) {
                t.next = 2;
                break;
              }

              return t.abrupt("return");

            case 2:
              return e && (this.containerElement = e), this.paypalUiInstance = new le(), this.paypalUiInstance.render(this.containerElement), t.abrupt("return");

            case 6:
            case "end":
              return t.stop();
          }
        }
      }, t, this);
    })), function (t) {
      return s.apply(this, arguments);
    })
  }, {
    key: "pay",
    value: (o = r(u.mark(function t(e, n) {
      var r;
      return u.wrap(function (t) {
        for (;;) {
          switch (t.prev = t.next) {
            case 0:
              return t.prev = 0, t.next = 3, mt(e.url, {
                paymentInstrument: {
                  paymentMethod: this.initData.paymentMethod
                }
              });

            case 3:
              return r = t.sent, t.abrupt("return", Ct(r, n));

            case 7:
              return t.prev = 7, t.t0 = t["catch"](0), t.abrupt("return", Ct(t.t0));

            case 10:
            case "end":
              return t.stop();
          }
        }
      }, t, this, [[0, 7]]);
    })), function (t, e) {
      return o.apply(this, arguments);
    })
  }, {
    key: "validate",
    value: (n = r(u.mark(function t() {
      return u.wrap(function (t) {
        for (;;) {
          switch (t.prev = t.next) {
            case 0:
              return t.abrupt("return", !0);

            case 1:
            case "end":
              return t.stop();
          }
        }
      }, t);
    })), function () {
      return n.apply(this, arguments);
    })
  }, {
    key: "destroy",
    value: function value() {
      this.containerElement.innerHTML = "", this.paypalUiInstance = null;
    }
  }, {
    key: "needRenderWidget",
    value: (e = r(u.mark(function t() {
      return u.wrap(function (t) {
        for (;;) {
          switch (t.prev = t.next) {
            case 0:
              return t.abrupt("return", !0);

            case 1:
            case "end":
              return t.stop();
          }
        }
      }, t);
    })), function () {
      return e.apply(this, arguments);
    })
  }]), t;
}();

var de = [/Trident\/7\.0.*rv\:([0-9\.]+).*\).*Gecko$/, /MSIE\s([0-9\.]+);.*Trident\/[4-7].0/, /MSIE\s(7\.0)/];

function he(t, e) {
  var n = "\n    <div style='width: 780px;padding: 153px 24px 24px;box-sizing:border-box;background: url(".concat("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAwIiBoZWlnaHQ9IjExMyIgdmlld0JveD0iMCAwIDIwMCAxMTMiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik0xNDggOTZINTFDNDcuNjg2MyA5NiA0NSA5My4zMTM3IDQ1IDkwVjI0QzQ1IDIwLjY4NjMgNDcuNjg2MyAxOCA1MSAxOEgxNDhDMTUxLjMxNCAxOCAxNTQgMjAuNjg2MyAxNTQgMjRWOTBDMTU0IDkzLjMxMzcgMTUxLjMxNCA5NiAxNDggOTZaIiBzdHJva2U9IiNEOEQ4RDgiIHN0cm9rZS13aWR0aD0iNCIvPgo8cGF0aCBkPSJNMTI2IDUxLjgwOVY4MC43MzM3QzEyNiA4MC44NDgxIDEyNi4wMDIgODAuOTU5NiAxMjYuMDEzIDgxLjA3MzVDMTI2LjE2MiA4Mi41OTIxIDEyNy44ODMgOTQuMDMwNiAxNDYuMzM2IDEwMC4zMzdDMTQ3LjY4IDEwMC43OTYgMTQ5LjEyNyAxMDAuODMyIDE1MC40NjkgMTAwLjM2N0MxNTUuMjkxIDk4LjY5NzYgMTY3LjEwMyA5My40NDE1IDE2OS45OTggODEuMjk4MkMxNzAuMDAzIDgxLjI2NjcgMTY5Ljk5OCA1MS44MDg3IDE2OS45OTggNTEuODA4N0wxNTAuMTExIDQ3LjM4MDJDMTQ4Ljk4NiA0Ny4xMjk3IDE0Ny44MiA0Ny4xMjUyIDE0Ni42OTMgNDcuMzY3MUwxMjYgNTEuODA5WiIgZmlsbD0iI0Y4RkFGQiIgc3Ryb2tlPSIjRDhEOEQ4IiBzdHJva2Utd2lkdGg9IjQiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNMTQxIDY4LjM4NDZDMTQxIDY0IDE0NC4xMzQgNjEgMTQ4IDYxQzE1MS44NjYgNjEgMTU1IDY0IDE1NSA2OC4zODQ2QzE1NSA3Mi40NjMgMTUxLjA2MiA3NS4zMDc3IDE0OCA3NS43NjkyQzE0OCA3Ny4xNTM4IDE0OCA3OSAxNDggNzkiIHN0cm9rZT0iI0Q4RDhEOCIgc3Ryb2tlLXdpZHRoPSI0IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPGNpcmNsZSBjeD0iMTQ4IiBjeT0iODYiIHI9IjIiIGZpbGw9IiNEOEQ4RDgiLz4KPHBhdGggZD0iTTQ3IDMzSDE1MyIgc3Ryb2tlPSIjRDhEOEQ4IiBzdHJva2Utd2lkdGg9IjQiLz4KPGNpcmNsZSBjeD0iMTMwIiBjeT0iMjUiIHI9IjIiIGZpbGw9IiNEOEQ4RDgiLz4KPGNpcmNsZSBjeD0iMTM4IiBjeT0iMjUiIHI9IjIiIGZpbGw9IiNEOEQ4RDgiLz4KPGNpcmNsZSBjeD0iMTQ2IiBjeT0iMjUiIHI9IjIiIGZpbGw9IiNEOEQ4RDgiLz4KPC9zdmc+Cg==", ") no-repeat center 40px/200px 113px;'>\n      <p style='margin: 0;padding: 0;text-align: center;font-size: 12px;line-height: 16px;color: #1e1e1e;opacity: 0.8'>").concat({
    de: "Entschuldigung, Ihr  Browser mit der aktuellen Benutzeroberfläche nicht kompatibel ist. Wir  empfehlen IE11/Chrome für eine optimale Verwendung.",
    en: "Sorry, this browser  is not supported, we suggest you to change to IE11/Chrome or other browsers  to try again",
    es: "Perdón, no es  compatible con el navegador actual, es recomendable intentar de nuevo con los  navegadores de IE11/Chrome, etc.",
    fr: "Désolé, le navigateur  actuel n’est pas compatible, il est recommandé de remplacer IE11 / Chrome et  d’autres navigateurs pour réessayer",
    ja: "申し訳ありませんが、このブラウザは現在サポートされていません  。IE11/ Chromeまたは他のブラウザに変更して再試行することをお勧めします",
    ru: "Извините, текущий  браузер несовместим, рекомендуется заменить на IE11 / Chrome или другие  браузеры для повторной попытки.",
    th: "ขออภัยค่ะ  เบราว์เซอร์ปัจจุบันไม่รองรับ ขอแนะนำให้เปลี่ยนเป็นเบราว์เซอร์ IE11/Chrome  เพื่อลองใหม่อีกครั้งค่ะ",
    "zh-CN": "抱歉，当前浏览器不兼容，建议更换IE11/Chrome等浏览器重试",
    "zh-TW": "抱歉，當前瀏覽器不相容，建議更換IE11/Chrome等瀏覽器重試",
    id: "Maaf, browser ini tidak  didukung, kami sarankan Anda mengubah ke IE11/Chrome atau browser lain untuk  coba lagi.",
    it: "Spiacenti, il browser attuale  non supporta, si consiglia di sostituire IE11/Chrome e altri browser per  riprovare",
    ko: "죄송합니다. 현재 인터넷을 겸용할 수 없고  IE11/Chrome 인터넷으로 교체하여 다시 시도하세요",
    nl: "Sorry, de huidige browser is  niet compatibel, wij raden u aan het opnieuw te proberen met IE11/Chrome of  andere browsers.",
    pl: "Przepraszam, bieżąca  przeglądarka nie jest kompatybilna, zaleca się zastąpienie IE11/Chrome i  innych przeglądarek, aby spróbować ponownie",
    pt: "Desculpe, o navegador atual não  é compatível, sugerimos que você tente novamente com o IE11/Chrome e outros  navegadores",
    vi: "Rất tiếc chúng tôi không hỗ trợ  trình duyệt này, bạn có thể sử dụng trình duyệt IE11/ Chrome hoặc các trình  duyệt khác và thử lại"
  }[e], "</p>\n    </div>\n  ");
  t.innerHTML = n;
}

function fe(t) {
  return t && !/^https?/.test(t) ? "https://".concat(t) : t;
}

vt(".block-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding: 24px;\n  background-color: #F8FAFB;\n}\n\n.block-container .block-img {\n  width: 200px;\n  height: 113px;\n  background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAMgAAABxCAYAAACQnewjAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAA0ZSURBVHgB7Z37ctP4FcfPT3JiO4HEsDRQ2s7am4QlOztD0hdIQh8A6P5fAg9QCg/QJC+wkD5AG/YBILwAeF+gDjOdTTYk2DMd6DakuTmQiy2p50h2kGXZkXyRZel8BuFYvoHz++rcfr/zA2AYhmEYhmEYhmEYhmEYhmEYhmEYhmEYhmEYRwjwgGx2Jamq4rEQkACfommQkyRYLha116OjY2lgGPBIIBsbq1m8SUL3kMMjLUnafCo1lgMmtHgkkJUd/CjfWo8zWGShhBcJPEBVYQG6lxlVlTJoBf8CTOjwxIIQFIcUi/51syIRcQOFPIXRyFQda/dkePj6Q2BCg2cC6SbW11dmhBCzYBM3YTC/nM8fTk9MTOwCE3hYIHWoJRQWSXhggZxBKUX9ClgkocSTIL2boewVZrGmwUj9noI1nfHBwfhzYAINC8QBtUSCVmQKs1v/ACawsIvlglruFrKI2a17wAQOFohLWCThggXSACyS8MACaRAWSThggTQBiyT4sECahEUSbFggFrLZjD4PK5VyXgBkkQQXroOY2Nj4eVZV4zt0ZLM/zzp9Xa06CTLDdZLuhgVSgXo6pV1VtTkWCcMulokaKx9z4AotYT9dXkOXTYR93hb9//FCIpZSqa+fQhfAAjGRzf5rXFXlV128+rGbyKJQ5v0uFBaIBRaJ5zzf3z+879dZ0RyDWEilvl2WJGXacIkYD7gzOBh/Bj6FLUgN6lgSvYkDMK6hJddCAC1Cm4TqWO8xpsQfgc9ggdShlkjQd55D35lF0gBYM6KblKaJZ5oG46aHNLzwfOW37jGBcbGohkFZKDyeZzKZlsQPtdwttylg5jMoAPz7KCvE0U2ozBAKRdEegM8IhEDevFmZwkE8B4bZvj0wEGtZix4WSetJpSbQ3YpiQVa7bz4vhHwXfEYgBIKmOll5RnwJLYRF0noikSM8jpcrv1MtQdN2wEcEQiDou1YMXE1TL0CLYZG0FrIiihLbxVgkZz7vt95pgRCILItl83001ZPQBlgkbcHX6fRACMTIfFSaaiMuacdnsUjCRGCyWGiqK6yIJFEb0fbAIgkPAaqkq5YG2dKDdgZ8LJJwEBiByPJx2upmoVVp6zRzFknwCYxAjBWAlVNAqLFbuwcqiyTYBGqy4vDwN09QFGnzOS8GKoskuARuNq8sa7QGPGc+RwOVpqFwTMK4JXACMZa+Fu/YTFenxgrZt29XX+GAvbu2tjYOLYZFEjwCO5u3TqcRK7laDwgBOVVVX2Owv+Rm51ueBeyM9fVVGn8v8XueKp3S8GJy00+7DAd2wVS5iYKmaWct6UzWOijIF0J6gAP7lWF5nLlobEmCQ6BXFJJIRkbGZjRNvWMN3t1CYqHNPNfXf7rt5PkskmAQqgVTb96szKE1aHpw4nvMOG02UGdl4sPh4etPIICUFkUlFUUbR/e0KtYTQlumupWixPfA5y5WBEIM/jLmIxFYrPU4/YLx13lbCHHX8rpFtALgRCRkSVAk09UiEbOZTGax27dwy2YzdJMoFmPjpZ2Cx43dgml5raA4zgaB32GcflhGsST9fJ32XCCUPRJCqbniT9Pk3WvXri2DR5yxxJMeW0LLk7NanuZFoiXOnYvP4A9dZUXK1qFQgCmM8cYVRZqk7egkib4TV2+lb2NnEQdqSjzG7/sF/pyORI6W3bSAbQeeSpeWw+KNIx+eNsnEr/xHtxmkelhdLLIg+N5zTl5b2vG2auqKG3fL+vkYG70YGfnG0ffRCcrWQVGiU3iLgpBuYNJj3MuWSDQOUEgYz4l0oSBee3nxJDwTiOGLRzLQGLlSirSpJmPNCIRoViQ230EO45AU+AxDGOKCpsWoscIUNABm/6Cntxd6e6PQ0xMFGX1ZTJnDyfEhnJwc4+0RNEiWlup6Fad46GIVcljn3m3w6pMklwYtEJn1+U51vsCM2CKKBKwicepuFYtyQjLlDanOAr4kRn8l3IiDBNDbG8ejF6LROIojavu8eLz/9OdjFEsBxWLcnmDMV3TwSUAXlCk80uABngmEfElMkd7DYVG3cwUOmiTULu7NYPFvCuOYO16b2jJniCRZrxBIPaHM93EA5qALIesQjcVOhUAWQpLcVwzo9XScO29cM0ksRRQJWZmjo0MoFk6g03gapKO/vYQ3S2c9j/boMPze6gwSkpRl7RWKZNqHIqE5XzPkDlL8VLZ0xp4j/bPoYlT8X8ivhi6BBnJf/3nojcYgEumBdqCLDaK6lRkE0F2yQuFYF8z+3g50Al+meUuZC11MmDWZUxTxDK++E5+foSVQJBkcjI/wKvwEA0cNfVLwEpNI/g6VsZzuDtKpjY0VvaM73keBqFbXMtstHc4JEgYJxEvIKpEwI3IPC6QWpavw72sU+b7H4094PFpfX03jIKRzWGyKoNlXqt6r6MjFdY4hkp920eWgf4dNsK3HW4nqXIi2g7/7m8D4nq4pFFK2CUVCbslfwTTiKJeOV/GXRloYfiwdObDploFFqUSrE3fkNqKVW1YUmC25g2d8AIlDuYm1kRwEnKNDco329KxVsXR1isUo5jiPt+iq9bTHVWslXVVJJ5GgW5NDUXxPaUjzY0bRSaJpDQ9kWUX/tXqcCtGerHbJyt1Docwb7TOlG6bpEyU0dLXgb1j8etLp4le7ITFsbW7qgbYVOkdHBLNeiQsXdbH4ma6bakJuDQ7ENA5Eh1ds7ygJ5WH5vnn2r9+aMrcLEscv79+dWox6z9v6sKkH4gODg+BXunIuVvmKjS7XU3S5/gyfq/O+mtQTFlGY2d7aOlMcZnZ3tqGvr8+37lZXT1YsVVPTdKU2JhbCJLk3eJtAF8dun8AL1kIlZsJCNaPZCRjPUbwGbqGY49OnjxXnKNYgVyoWj+vCOcjvoyg+Z6TIgmx9+ABXrl4FPxKI2bylKzUddWssRiYMTjNh6KLdwpuWNroOAiQQTROu+xsfHOQr7pM4rlz9zen9ctxBdRRyr8pQTEJCaaTY2G5CPd3dCOyh5WvTw8rJ8XHFfRKDHRSY7+/tYnbrc6WcrE9ffz/4Dd6jkGkZ5gFPkFtVi95o5VwtVVXAj4TagpRw72yHB1fxGblIamlRCLlT9VAVfwrCStgFsoTB/QtgqqCiKg74x25ec/GLS3pWikRSy70iKFi3Wpt2ze9qlrAvuX197drYIjAVGKsGRQrHuSuBUGzhpPBnTQWTtannjnUSdrEYz6BAfHv7f1XBvJ+r6SwQpu1Q3YOyVqrNovVy6tevsECYtkJWg+ISO0gcV37tzwJhGRYI0xFo/hVZDj8WB82wQBhPIatx6VdDvg3KrXChkPEUP2es7GCBMG2FKuZmN6qv/xx0E6F3sWiVIlMJFbllGVoCiWPo8hU4yOch0hPx9doPO0ItEEkSX2KxcBqYCmg2b6FA3WOgJZBL1YxbpXRwnlbYLQi16JkB5kya6ITYNJ3sj8VZLMYR1J+qkTUb5vXp1IZ06PJl16sHP33MW095NsGUg3TGESSOg7z7XhObv/zntHkDdTeh1YNuIIFRa1ITGibCPOsnFnYLkkN/OwuMLaVly6cN+z4e7OltQt1YEeusXbtOJ/XI729b/01pL9f6h30271M33d3DRLnDu6pG35bX8ZMVye/vwGDiC8fvQ32wzKKwLpSqB7lWFvdKE0Isgoewi8XYkkpNoHsT3UFNLJjPk5tlExPU5NLQkN7xnaA16kNDlx29jlyrfYv1QGufSaW+/gE8JFQCsXZTl2Uxmck0umVJ8IlEjvA4JoFUuKF7u1t60O7sPSJw9be/g+RXw3oDBycButHp5B0ole2DNFnWvgOPCZVAenqUim7wtMEk+rSuu3eEBbIiOMSpVep31DK1fF4fwJvv4ejwI7QaQxzvq8SBfzqyL0zoekJtbKzS1TBpOrWItZB7aLqBsYe62CO2u2sNDFyE84OtucYY3Rbf2YgDloaHr/8ROkAIYxB1wXJiBg/a10PQLlFra2vlvfmYEiMjY+SeLtKWddbHKE7Y2d7EwV2AZjjGQH7zv/+2ikOPOyTp8D50iFB2FXz7dvWf+MVPWE7TPojztFFkT8+nnKrGAt1guhGMhnLaXKnDfgW0BRtZE7d7iOiZsb0dODjYrf44FIcsH/6hk82+QykQalWqquIl2O7pwTSDU6GQMD7m9yCPwtCql+LSnkhPZfnoYai2gfYTLJL2QkLp7xuAeP+5ipY+ZwiDoNMPR0evL4APCHXjZqPp9enGNwQ3sm4DtI2aLEf0XWwt00bMkEu1LMvF+6nUtx3Ze9IOHhBQ3sdD3EKx3DJ22dV3ompku2rG/ZjSSpsLLYyOjs2Dz2CBMC3BaDYHZYs8CUYqvd74OhUGFiQX/LrrFguEaSmlFHlCUWK3cXjdRYs8aX0OulJpWaatKg5/8Pt2dCwQpm2UrQqWNpLlcxi758K48xbDMAzDMAzDMAzDMAzDMAzDMAzDMAzDMAzDMAzDMIwt/weNkaUFynax7AAAAABJRU5ErkJggg==');\n  background-repeat: no-repeat;\n  background-size: 100% 100%;\n  margin-bottom: 16px;\n}\n\n.block-container .block-tips {\n  font-size: 12px;\n  line-height: 16px;\n  color: #1E1E1E;\n  font-family: Helvetica;\n}", {});

var ve = function t() {
  var e = this;
  i(this, t), c(this, "mount", function () {
    var t = r(u.mark(function t(n, r) {
      var i;
      return u.wrap(function (t) {
        for (;;) {
          switch (t.prev = t.next) {
            case 0:
              return t.next = 2, e.getText(r.host, r.language);

            case 2:
              i = t.sent, dt({
                content: "div",
                props: {
                  "class": "block-container"
                },
                children: [{
                  content: "div",
                  props: {
                    "class": "block-img"
                  }
                }, {
                  content: "div",
                  props: {
                    "class": "block-tips"
                  },
                  children: i
                }]
              }, n);

            case 5:
            case "end":
              return t.stop();
          }
        }
      }, t);
    }));
    return function (e, n) {
      return t.apply(this, arguments);
    };
  }()), c(this, "getText", function () {
    var t = r(u.mark(function t(e, n) {
      var r, i;
      return u.wrap(function (t) {
        for (;;) {
          switch (t.prev = t.next) {
            case 0:
              return t.next = 2, re(n, !1, e);

            case 2:
              return r = t.sent, i = r.paymentMethodNotSupported, t.abrupt("return", i);

            case 5:
            case "end":
              return t.stop();
          }
        }
      }, t);
    }));
    return function (e, n) {
      return t.apply(this, arguments);
    };
  }());
};

function ye(t, e) {
  var n = Object.keys(t);

  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(t);
    e && (r = r.filter(function (e) {
      return Object.getOwnPropertyDescriptor(t, e).enumerable;
    })), n.push.apply(n, r);
  }

  return n;
}

function me(t) {
  for (var e = 1; e < arguments.length; e++) {
    var n = null != arguments[e] ? arguments[e] : {};
    e % 2 ? ye(Object(n), !0).forEach(function (e) {
      c(t, e, n[e]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : ye(Object(n)).forEach(function (e) {
      Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
    });
  }

  return t;
}

var ge = function () {
  var e = r(u.mark(function e(n) {
    var r, i, o, a, c, s, l, p;
    return u.wrap(function (e) {
      for (;;) {
        switch (e.prev = e.next) {
          case 0:
            return r = n.merchantId, i = n.countryCode, o = n.paymentMethod, a = n.currency, c = n.channelId, s = n.host, l = "".concat(s || "https://cashiers.myshopline.com", "/v1/api/cashier/init"), e.next = 4, G.post(l, {
              merchantId: r,
              countryCode: i,
              paymentMethod: o,
              currency: a,
              channelId: c
            }).then(function (t) {
              return t.data.status = "SUCCESS", t.data;
            })["catch"](function (e) {
              var n;
              return Wt({
                pvId: t
              }, "validate_card", null), n = {
                statusCode: null == e ? void 0 : e.statusCode,
                url: l,
                response: null == e ? void 0 : e.data
              }, Y.report(new Error(JSON.stringify(n))), e.data.status = "FAIL", e.data;
            });

          case 4:
            return p = e.sent, e.abrupt("return", p);

          case 6:
          case "end":
            return e.stop();
        }
      }
    }, e);
  }));
  return function (t) {
    return e.apply(this, arguments);
  };
}(),
    be = function () {
  function e(n) {
    var o = this;
    i(this, e), c(this, "initData", void 0), c(this, "checkResult", void 0), c(this, "renderFail", function () {
      var e = r(u.mark(function e(n) {
        var r;
        return u.wrap(function (e) {
          for (;;) {
            switch (e.prev = e.next) {
              case 0:
                return Wt(me(me({}, o.initData), {}, {
                  pvId: t
                }), "render_fail"), r = new ve(), e.next = 4, r.mount(n, o.initData);

              case 4:
              case "end":
                return e.stop();
            }
          }
        }, e);
      }));
      return function (t) {
        return e.apply(this, arguments);
      };
    }()), this.initData = n, this.checkResult = ge(this.initData);
  }

  var n;
  return a(e, [{
    key: "getCheckResult",
    value: (n = r(u.mark(function t() {
      return u.wrap(function (t) {
        for (;;) {
          switch (t.prev = t.next) {
            case 0:
              return t.abrupt("return", this.checkResult);

            case 1:
            case "end":
              return t.stop();
          }
        }
      }, t, this);
    })), function () {
      return n.apply(this, arguments);
    })
  }]), e;
}();

function we(t, e) {
  var n = Object.keys(t);

  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(t);
    e && (r = r.filter(function (e) {
      return Object.getOwnPropertyDescriptor(t, e).enumerable;
    })), n.push.apply(n, r);
  }

  return n;
}

function Ae(t) {
  for (var e = 1; e < arguments.length; e++) {
    var n = null != arguments[e] ? arguments[e] : {};
    e % 2 ? we(Object(n), !0).forEach(function (e) {
      c(t, e, n[e]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : we(Object(n)).forEach(function (e) {
      Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
    });
  }

  return t;
}

var xe = function () {
  function t(e, n) {
    var o,
        a,
        s,
        l = this;

    try {
      i(this, t), c(this, "initData", void 0), c(this, "element", void 0), c(this, "paySession", void 0), c(this, "scene", void 0), c(this, "metaData", void 0), c(this, "isNotSupportBrowser", void 0), c(this, "sessionId", void 0), c(this, "reportData", void 0), c(this, "renderChecker", void 0), c(this, "check", function () {
        if (l.isNotSupportBrowser) throw new Error("no support browser");
      }), c(this, "init", r(u.mark(function t() {
        return u.wrap(function (t) {
          for (;;) {
            switch (t.prev = t.next) {
              case 0:
                if (Wt(l.reportData, "init_start"), l.check(), !l.element) {
                  t.next = 5;
                  break;
                }

                return t.next = 5, l.renderWidget(l.element);

              case 5:
                return l.paySession = new ut(l.initData.host).init().then(function (t) {
                  return Wt(l.reportData, "init_end", t.sessionId), l.sessionId = t.sessionId, Ae(Ae({}, t), {}, {
                    paymentMethod: l.initData.paymentMethod,
                    channelId: l.initData.channelId,
                    language: l.parseLanguage()
                  });
                }), t.abrupt("return", l);

              case 7:
              case "end":
                return t.stop();
            }
          }
        }, t);
      }))), c(this, "renderWidget", function () {
        var t = r(u.mark(function t(e) {
          var n, r, i, o;
          return u.wrap(function (t) {
            for (;;) {
              switch (t.prev = t.next) {
                case 0:
                  if (Wt(l.reportData, "render_start", l.sessionId), n = e, "string" == typeof e && (n = document.querySelector(e), console.assert(n, "请检查元素 ".concat(e, " 是否存在, 注意: id 需要加 '#' 前缀, class 需要加 '.' 前缀"))), !l.isNotSupportBrowser) {
                    t.next = 7;
                    break;
                  }

                  return r = l.parseLanguage(), he(n, r), t.abrupt("return");

                case 7:
                  return i = l.metaData.paymentMethod, t.next = 10, l.scene.needRenderWidget();

                case 10:
                  if (!t.sent) {
                    t.next = 28;
                    break;
                  }

                  return t.next = 14, l.renderChecker.getCheckResult();

                case 14:
                  if ("SUCCESS" !== (o = t.sent).status) {
                    t.next = 22;
                    break;
                  }

                  return l.scene && l.scene.setPaymentMethodInfo && l.scene.setPaymentMethodInfo(o.paymentMethodInfo), t.next = 19, l.scene.render(n);

                case 19:
                  l.scene && l.scene.setSupportCardBrands && l.scene.setSupportCardBrands(o.brands || []), t.next = 25;
                  break;

                case 22:
                  if ("FAIL" !== o.status) {
                    t.next = 25;
                    break;
                  }

                  return t.next = 25, l.renderChecker.renderFail(n);

                case 25:
                  Wt(l.reportData, "render_end", l.sessionId), t.next = 29;
                  break;

                case 28:
                  console.warn('支付方式 "'.concat(i, '" 不需要渲染控件'));

                case 29:
                case "end":
                  return t.stop();
              }
            }
          }, t);
        }));
        return function (e) {
          return t.apply(this, arguments);
        };
      }()), c(this, "getPaySession", r(u.mark(function t() {
        return u.wrap(function (t) {
          for (;;) {
            switch (t.prev = t.next) {
              case 0:
                return Wt(l.reportData, "get_paySession", l.sessionId), t.t0 = JSON, t.next = 4, l.paySession;

              case 4:
                return t.t1 = t.sent, t.abrupt("return", t.t0.stringify.call(t.t0, t.t1));

              case 6:
              case "end":
                return t.stop();
            }
          }
        }, t);
      }))), c(this, "needRenderWidget", r(u.mark(function t() {
        return u.wrap(function (t) {
          for (;;) {
            switch (t.prev = t.next) {
              case 0:
                return t.next = 2, l.renderChecker.getCheckResult();

              case 2:
                if ("FAIL" !== t.sent.status) {
                  t.next = 5;
                  break;
                }

                return t.abrupt("return", !0);

              case 5:
                if (!l.isNotSupportBrowser) {
                  t.next = 7;
                  break;
                }

                return t.abrupt("return", !1);

              case 7:
                return t.next = 9, l.scene.needRenderWidget();

              case 9:
                return t.abrupt("return", t.sent);

              case 10:
              case "end":
                return t.stop();
            }
          }
        }, t);
      }))), c(this, "validate", r(u.mark(function t() {
        var e;
        return u.wrap(function (t) {
          for (;;) {
            switch (t.prev = t.next) {
              case 0:
                return t.next = 2, l.renderChecker.getCheckResult();

              case 2:
                if ("FAIL" !== t.sent.status) {
                  t.next = 5;
                  break;
                }

                return t.abrupt("return", !1);

              case 5:
                return Wt(l.reportData, "validate_start", l.sessionId), t.next = 8, l.scene.validate();

              case 8:
                return e = t.sent, Wt(l.reportData, "validate_end", l.sessionId), t.abrupt("return", e);

              case 11:
              case "end":
                return t.stop();
            }
          }
        }, t);
      }))), c(this, "pay", function () {
        var t = r(u.mark(function t(e, n) {
          var i, o;
          return u.wrap(function (t) {
            for (;;) {
              switch (t.prev = t.next) {
                case 0:
                  return Wt(l.reportData, "call_pay_start", l.sessionId), t.next = 3, l.paySession;

                case 3:
                  return i = t.sent, t.next = 6, l.scene.pay(e, Ae(Ae({}, n), {}, {
                    beforeRedirect: function () {
                      var t = r(u.mark(function t(e) {
                        return u.wrap(function (t) {
                          for (;;) {
                            switch (t.prev = t.next) {
                              case 0:
                                if (Wt(l.reportData, "call_pay_end_with_redirect", l.sessionId), null == n || !n.beforeRedirect) {
                                  t.next = 3;
                                  break;
                                }

                                return t.abrupt("return", n.beforeRedirect(e));

                              case 3:
                              case "end":
                                return t.stop();
                            }
                          }
                        }, t);
                      }));
                      return function (e) {
                        return t.apply(this, arguments);
                      };
                    }(),
                    sessionId: i.sessionId
                  }));

                case 6:
                  return o = t.sent, Wt(l.reportData, "call_pay_end", l.sessionId), t.abrupt("return", o);

                case 9:
                case "end":
                  return t.stop();
              }
            }
          }, t);
        }));
        return function (e, n) {
          return t.apply(this, arguments);
        };
      }()), c(this, "destroy", function () {
        Wt(l.reportData, "destroy_SDK", l.sessionId), l.scene.destroy();
      }), Y.setTag("host", e.host || "https://cashiers.myshopline.com"), this.reportData = Ae({}, e), e.channelId = void 0 !== e.channelId ? e.channelId : "SLPayments", Vt.init({
        channel_id: e.channelId,
        consumer: e.clientId
      }), Wt(this.reportData, "constructor_start"), e.host = fe(e.host), this.initData = Object.freeze(e), this.isNotSupportBrowser = (s = navigator.userAgent, de.every(function (t) {
        var e = t.exec(s);
        return !!(e && Number(e[1]) < 11);
      })), this.check(), this.metaData = Object.freeze((o = this.initData, a = {}, ["currency", "countryCode", "channelId", "paymentMethod", "merchantId"].forEach(function (t) {
        void 0 !== o.hasOwnProperty(t) && (a[t] = o[t]);
      }), a)), this.element = n, this.scene = function (t) {
        var e;

        switch (t.paymentMethod) {
          case $.Paypal:
            e = new pe(t);
            break;

          case $.CreditCard:
            e = new ce(t);
            break;

          case $.Cash:
          case $.BankTransfer:
          case $.ChannelCashier:
          case $.VirtualAccount:
            e = new ue(t);
            break;

          default:
            e = new ue(t);
        }

        return e;
      }(this.initData), this.renderChecker = new be(this.initData), Wt(this.reportData, "constructor_end");
    } catch (t) {
      var p = t;
      throw p instanceof Object || (p = new Error(p)), p.isSent || (p.isSent = 1, Y.report(p)), p;
    }
  }

  return a(t, [{
    key: "parseLanguage",
    value: function value() {
      var t = this.initData.language,
          e = void 0 === t ? "en" : t;
      return "string" == typeof e ? e : (null == e ? void 0 : e.extend) || "en";
    }
  }]), t;
}(),
    Ce = function Ce(t) {
  return t = fe(t), Wt({}, "init_risk_start"), new ut(t).init().then(function (t) {
    Wt({}, "init_risk_end", t.sessionId);
  });
};

export { xe as Payment, $ as PaymentMethod, Ce as initRisk, U as version };